var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlatinum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 64,
    viewBox: "0 0 96 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_578_447501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8677 49.0129L45.5287 55.713C46.9644 56.4226 48.6221 56.4226 50.0578 55.713L62.2639 47.3959L63.0863 43.4464L47.5909 47.6236L33.625 45.6362L33.8677 49.0129Z",
    fill: "url(#paint0_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8677 49.0129L45.5287 55.713C46.9644 56.4226 48.6221 56.4226 50.0578 55.713L62.2639 47.3959L63.0863 43.4464L47.5909 46.8992L33.625 45.6362L33.8677 49.0129Z",
    fill: "url(#paint1_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8677 49.0129L45.5287 55.713C46.9644 56.4226 48.6221 56.4226 50.0578 55.713L62.2639 47.3959L63.0863 43.4464L47.5909 46.8992L33.625 45.6362L33.8677 49.0129Z",
    fill: "url(#paint2_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2741 26.9353L63.5352 40.8237L62.964 43.7092L50.2116 52.4451C48.7967 53.2061 47.1741 53.2061 45.7722 52.4451L33.7515 45.8814L33.0635 42.3935L30.4414 29.1233L33.752 30.9783L36.5429 37.1932L41.0861 39.4128L45.4347 41.5373L47.9789 45.8814L50.5232 41.5373L54.4823 39.6031L59.4279 37.1932L62.2188 30.9783L66.2741 26.9353Z",
    fill: "url(#paint3_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9607 43.6409L50.2135 52.456C48.7977 53.217 47.1872 53.217 45.7714 52.456L33.7444 45.8919L30.6012 29.9107L30.4453 29.8314L33.7444 46.6053L45.7714 53.1694C47.1872 53.9304 48.7977 53.9304 50.2135 53.1694L62.9607 44.3544L66.2598 27.5804L66.1039 27.6597L62.9607 43.6409Z",
    fill: "url(#paint4_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2373 29.3547C66.639 32.3257 59.7719 31.7002 59.7719 31.7002C59.6152 31.596 59.4585 31.4918 59.328 31.3875C56.038 28.9377 58.9363 27.9604 58.9363 27.9604C62.3177 27.8822 67.6443 25.0676 71.7176 22.5396C73.7021 21.3147 75.3993 20.1549 76.4437 19.4382C77.1487 18.943 77.5534 18.6434 77.5534 18.6434C81.5484 18.9561 84.9037 18.6824 86.6661 18.4739C87.4886 18.3827 87.9586 18.2915 87.9848 18.2915C84.1595 24.1424 79.0548 27.4782 74.2373 29.3547Z",
    fill: "url(#paint5_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9847 18.2915C87.8933 18.3697 83.0628 22.305 77.6317 22.5396C76.4697 22.5917 75.2947 22.4744 74.1328 22.1095C74.1328 22.1095 75.3731 20.4676 76.4567 19.4382C76.8745 19.0473 77.2661 18.7346 77.5664 18.6434C78.4411 18.7085 79.2897 18.7476 80.0861 18.7737C82.9583 18.8388 85.3083 18.6433 86.6791 18.4739C87.5016 18.3697 87.9586 18.3045 87.9847 18.2915Z",
    fill: "url(#paint6_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.772 31.7002C59.6153 31.596 59.4587 31.4918 59.3281 31.3875C74.3941 31.4527 83.7288 21.9923 86.6793 18.4739C87.528 18.3827 87.9979 18.2915 87.9979 18.2915C78.1149 33.3812 59.772 31.7002 59.772 31.7002Z",
    fill: "url(#paint7_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6375 21.5889C83.6375 21.5889 78.1281 27.7004 66.7959 30.5541C66.7959 30.5672 76.8617 29.5377 83.6375 21.5889Z",
    fill: "url(#paint8_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5006 22.553C77.5006 22.553 67.5654 31.4139 60.6982 31.2315C60.6982 31.2315 73.5971 24.5467 75.1898 22.3445C75.2029 22.3445 76.0123 22.5009 77.5006 22.553Z",
    fill: "url(#paint9_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0861 18.7869C80.0208 19.9076 77.9058 22.4616 77.5533 22.5659C76.4045 22.618 75.3078 22.4747 74.1328 22.1228C74.1328 22.1228 75.3731 20.4809 76.4567 19.4515C76.8745 19.0606 77.2661 18.7478 77.5664 18.6566C78.4411 18.7218 79.2897 18.7609 80.0861 18.7869Z",
    fill: "url(#paint10_radial_578_447501)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0039 22.4189C78.0039 22.4189 82.8866 21.5458 86.02 19.3306C86.02 19.3306 83.6047 21.8846 78.0039 22.4189Z",
    fill: "url(#paint11_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5199 23.4615C69.4252 29.8336 63.1653 32.7255 63.1653 32.7255C62.9775 32.7136 62.7897 32.7016 62.6245 32.6766C58.5504 32.2 60.5717 29.9045 60.5717 29.9045C63.461 28.1461 66.6667 23.0452 68.9303 18.8193C70.0364 16.7663 70.9263 14.9133 71.4725 13.7704C71.8354 12.989 72.0361 12.5272 72.0361 12.5272C75.6522 10.8005 78.4211 8.88586 79.8432 7.82406C80.5099 7.33381 80.8714 7.01982 80.894 7.00677C80.5066 13.9864 77.7538 19.4277 74.5199 23.4615Z",
    fill: "url(#paint12_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8945 7.00668C80.8545 7.12009 78.6388 12.9435 74.0526 15.8621C73.0724 16.4882 71.9961 16.9741 70.8074 17.2391C70.8074 17.2391 71.0606 15.1971 71.4843 13.7637C71.6507 13.2163 71.8335 12.7497 72.0479 12.5205C72.8381 12.1396 73.5925 11.7492 74.2952 11.3735C76.8152 9.99385 78.7526 8.64955 79.8551 7.81743C80.5153 7.31591 80.8784 7.03102 80.8945 7.00668Z",
    fill: "url(#paint13_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1659 32.7253C62.9781 32.7134 62.7903 32.7014 62.6252 32.6764C75.7053 25.1999 79.0591 12.3396 79.8552 7.81733C80.5445 7.31403 80.9059 7.00006 80.9059 7.00006C79.8919 25.0097 63.1659 32.7253 63.1659 32.7253Z",
    fill: "url(#paint14_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7776 12.0359C78.7776 12.0359 77.0621 20.0833 68.675 28.2208C68.6815 28.2321 76.884 22.3077 78.7776 12.0359Z",
    fill: "url(#paint15_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9456 15.9392C73.9456 15.9392 69.7719 28.5806 63.7335 31.8562C63.7335 31.8562 71.5618 19.6176 71.8401 16.914C71.8514 16.9075 72.6306 16.6382 73.9456 15.9392Z",
    fill: "url(#paint16_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3019 11.385C74.8057 12.3881 74.2511 15.6575 73.9979 15.924C73.029 16.5436 72.0077 16.9678 70.8142 17.2506C70.8142 17.2506 71.0673 15.2086 71.491 13.7752C71.6574 13.2278 71.8402 12.7611 72.0546 12.532C72.8447 12.151 73.5992 11.7606 74.3019 11.385Z",
    fill: "url(#paint17_radial_578_447501)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3147 15.5714C74.3147 15.5714 78.1067 12.3739 79.7126 8.88883C79.7126 8.88883 78.898 12.3083 74.3147 15.5714Z",
    fill: "url(#paint18_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1168 23.5712C25.2116 29.9434 31.4715 32.8353 31.4715 32.8353C31.6593 32.8233 31.847 32.8114 32.0122 32.7864C36.0863 32.3098 34.065 30.0143 34.065 30.0143C31.1757 28.2559 27.9701 23.155 25.7065 18.929C24.6003 16.876 23.7104 15.023 23.1643 13.8801C22.8013 13.0988 22.6006 12.6369 22.6006 12.6369C18.9845 10.9103 16.2156 8.9956 14.7935 7.9338C14.1268 7.44356 13.7654 7.12957 13.7428 7.11651C14.1301 14.0961 16.8829 19.5374 20.1168 23.5712Z",
    fill: "url(#paint19_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7422 7.11642C13.7823 7.22983 15.998 13.0532 20.5841 15.9719C21.5643 16.598 22.6406 17.0839 23.8293 17.3489C23.8293 17.3489 23.5761 15.3068 23.1524 13.8735C22.9861 13.326 22.8032 12.8594 22.5888 12.6303C21.7987 12.2493 21.0442 11.8589 20.3415 11.4833C17.8215 10.1036 15.8841 8.75929 14.7816 7.92718C14.1215 7.42565 13.7583 7.14076 13.7422 7.11642Z",
    fill: "url(#paint20_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4708 32.8351C31.6586 32.8231 31.8464 32.8112 32.0116 32.7862C18.9314 25.3096 15.5776 12.4493 14.7815 7.92707C14.0922 7.42378 13.7308 7.1098 13.7308 7.1098C14.7448 25.1194 31.4708 32.8351 31.4708 32.8351Z",
    fill: "url(#paint21_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8591 12.1456C15.8591 12.1456 17.5746 20.1931 25.9617 28.3306C25.9552 28.3418 17.7527 22.4174 15.8591 12.1456Z",
    fill: "url(#paint22_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6911 16.0489C20.6911 16.0489 24.8648 28.6903 30.9032 31.9659C30.9032 31.9659 23.0749 19.7273 22.7966 17.0237C22.7853 17.0172 22.0061 16.7479 20.6911 16.0489Z",
    fill: "url(#paint23_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3348 11.4947C19.831 12.4979 20.3856 15.7672 20.6388 16.0338C21.6077 16.6534 22.6291 17.0776 23.8226 17.3604C23.8226 17.3604 23.5694 15.3183 23.1457 13.885C22.9793 13.3375 22.7965 12.8709 22.5821 12.6417C21.792 12.2608 21.0375 11.8703 20.3348 11.4947Z",
    fill: "url(#paint24_radial_578_447501)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.322 15.6812C20.322 15.6812 16.53 12.4837 14.9241 8.99857C14.9241 8.99857 15.7387 12.4181 20.322 15.6812Z",
    fill: "url(#paint25_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2844 37.6151L52.5295 29.7838L52.0658 24.9891C52.0658 24.9891 69.8645 23.995 83.5033 11.8375C83.4891 11.8352 83.4358 29.5428 53.2844 37.6151Z",
    fill: "url(#paint26_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2296 37.6306L52.4636 29.8262C76.9529 27.4411 83.4891 11.9347 83.4891 11.9347C83.4891 11.9347 83.4559 29.5819 53.2296 37.6306Z",
    fill: "url(#paint27_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6036 15.9168C80.6036 15.9168 75.4652 24.2713 65.6858 27.3204C65.6716 27.3181 75.0456 26.4471 80.6036 15.9168Z",
    fill: "url(#paint28_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4562 24.0641C81.3779 24.2466 75.2418 38.3721 54.1572 32.9773V23.582C54.1572 23.582 69.2494 26.8658 81.4562 24.0641Z",
    fill: "url(#paint29_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4568 24.0646C81.3785 24.247 75.2424 38.3725 54.1709 32.9777V28.899C72.7488 32.8865 81.3393 24.1688 81.4568 24.0646Z",
    fill: "url(#paint30_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3291 29.9287C62.3291 29.9287 70.1493 31.2448 76.9773 27.0619C76.9773 27.0749 71.8074 29.7072 62.3291 29.9287Z",
    fill: "url(#paint31_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3799 36.7567C69.2363 36.8218 61.4291 40.3141 54.1572 35.6491V28.899C54.1572 28.899 62.0036 33.2514 69.3799 36.7567Z",
    fill: "url(#paint32_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3799 36.7562C69.2363 36.8214 61.4291 40.3136 54.1572 35.6355V32.6515C62.7347 37.5772 69.2494 36.7823 69.3799 36.7562Z",
    fill: "url(#paint33_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5615 34.0531C56.5615 34.0531 63.5646 37.3132 69.3603 36.7094C69.3603 36.7094 66.2255 36.7015 62.5987 35.985C60.5887 35.5879 58.4376 34.8895 56.5615 34.0531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0154 18.6545C72.0154 18.6545 73.1873 21.2634 70.2681 24.5633C69.0334 25.959 65.2171 28.3122 62.6529 31.2901C59.1543 35.353 56.9196 40.0364 56.9196 40.0364L54.1475 28.1743L63.8911 22.9829L69.0786 20.216L72.0154 18.6545Z",
    fill: "url(#paint34_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.918 18.598C71.484 19.1733 72.4599 23.0316 66.9016 26.0223C64.6951 27.2095 63.6592 27.2407 63.6592 27.2407C63.6592 27.2407 62.5777 29.4298 60.8801 31.2006C59.1824 32.9715 56.9414 33.8285 56.9414 33.8285L57.8678 29.3887L61.998 24.0631L62.2484 23.6686L71.918 18.598Z",
    fill: "url(#paint35_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5298 23.1393C70.6604 23.9602 70.6865 24.6769 70.6343 25.3023C70.3601 29.0813 67.4096 29.9023 67.4096 29.9023C67.6446 34.2806 58.0619 38.3462 58.0619 38.3462L57.7485 37.4341L57.8921 37.2517L57.2002 32.9124L67.8404 25.1069L69.8248 22.6962L70.5298 23.1393Z",
    fill: "url(#paint36_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6469 25.3153C70.3727 29.0942 67.4222 29.9152 67.4222 29.9152L66.8086 29.2637L68.9105 25.2111L70.6469 25.3153Z",
    fill: "url(#paint37_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7476 37.4336C57.7476 37.4336 67.0301 33.4853 66.8082 29.2502C66.8082 29.2502 70.6987 28.1817 69.824 22.6957C69.824 22.6957 67.7148 24.7761 63.806 27.7744C59.8972 30.7728 56.9121 32.1691 56.9121 32.1691L57.7476 37.4336Z",
    fill: "url(#paint38_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7034 30.1893C66.7034 30.1893 65.6335 33.4892 60.4248 35.985C60.4131 35.985 65.9039 33.6811 66.7034 30.1893Z",
    fill: "url(#paint39_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.54 28.8854C67.54 28.8854 69.8639 28.1817 69.89 24.2725C69.89 24.2725 69.7986 27.6605 67.54 28.8854Z",
    fill: "url(#paint40_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5505 20.9308L52.8789 27.4462L53.5447 31.6291L53.4142 31.7594L53.6753 32.5022C53.6753 32.5022 61.8611 27.3811 62.8663 25.1919C63.8716 23.0027 66.9266 19.6017 66.9266 19.6017L66.6655 18.8589L64.5505 20.9308Z",
    fill: "url(#paint41_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5505 20.9308L52.8789 27.4462L53.5447 31.6291L53.4142 31.7594L53.6753 32.5022C53.6753 32.5022 61.8611 27.3811 62.8663 25.1919C63.8716 23.0027 66.9266 19.6017 66.9266 19.6017L66.6655 18.8589L64.5505 20.9308Z",
    fill: "#424242",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.428 31.7594C53.428 31.7594 61.6137 26.6383 62.619 24.4491C63.6243 22.2599 66.6793 18.8589 66.6793 18.8589L52.6055 26.7035L53.428 31.7594Z",
    fill: "url(#paint42_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7021 28.2148C58.7021 28.2148 61.8877 26.2341 62.6188 24.4489C62.6188 24.4489 61.3263 26.2601 58.7021 28.2148Z",
    fill: "url(#paint43_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.428 31.7594C53.428 31.7594 61.6137 26.6383 62.619 24.4491C63.6243 22.2599 66.6793 18.8589 66.6793 18.8589L52.6055 26.7035L53.428 31.7594Z",
    fill: "url(#paint44_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7226 29.3547C29.3209 32.3257 36.1881 31.7002 36.1881 31.7002C36.3448 31.596 36.5014 31.4918 36.632 31.3875C39.922 28.9377 37.0236 27.9604 37.0236 27.9604C33.6423 27.8822 28.3156 25.0676 24.2423 22.5396C22.2579 21.3147 20.5607 20.1549 19.5163 19.4382C18.8113 18.943 18.4065 18.6434 18.4065 18.6434C14.4116 18.9561 11.0563 18.6824 9.29382 18.4739C8.47132 18.3827 8.00131 18.2915 7.9752 18.2915C11.8005 24.1424 16.9052 27.4782 21.7226 29.3547Z",
    fill: "url(#paint45_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97527 18.2915C8.06666 18.3697 12.8972 22.305 18.3283 22.5396C19.4902 22.5917 20.6652 22.4744 21.8271 22.1095C21.8271 22.1095 20.5869 20.4676 19.5033 19.4382C19.0855 19.0473 18.6938 18.7346 18.3936 18.6434C17.5188 18.7085 16.6702 18.7476 15.8738 18.7737C13.0016 18.8388 10.6516 18.6433 9.28082 18.4739C8.45833 18.3697 8.00138 18.3045 7.97527 18.2915Z",
    fill: "url(#paint46_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.188 31.7002C36.3446 31.596 36.5013 31.4918 36.6318 31.3875C21.5658 31.4527 12.2311 21.9923 9.28061 18.4739C8.43201 18.3827 7.96203 18.2915 7.96203 18.2915C17.845 33.3812 36.188 31.7002 36.188 31.7002Z",
    fill: "url(#paint47_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3225 21.5889C12.3225 21.5889 17.8319 27.7004 29.1641 30.5541C29.1641 30.5672 19.0983 29.5377 12.3225 21.5889Z",
    fill: "url(#paint48_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4593 22.553C18.4593 22.553 28.3945 31.4139 35.2617 31.2315C35.2617 31.2315 22.3629 24.5467 20.7701 22.3445C20.7571 22.3445 19.9477 22.5009 18.4593 22.553Z",
    fill: "url(#paint49_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8738 18.7869C15.9391 19.9076 18.0541 22.4616 18.4066 22.5659C19.5555 22.618 20.6522 22.4747 21.8271 22.1228C21.8271 22.1228 20.5869 20.4809 19.5033 19.4515C19.0855 19.0606 18.6938 18.7478 18.3936 18.6566C17.5188 18.7218 16.6702 18.7609 15.8738 18.7869Z",
    fill: "url(#paint50_radial_578_447501)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9561 22.4189C17.9561 22.4189 13.0733 21.5458 9.94001 19.3306C9.94001 19.3306 12.3553 21.8846 17.9561 22.4189Z",
    fill: "url(#paint51_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6755 37.6149L43.4304 29.7836L43.8942 24.989C43.8942 24.989 26.0954 23.9949 12.4566 11.8373C12.4708 11.8351 12.5242 29.5427 42.6755 37.6149Z",
    fill: "url(#paint52_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7303 37.6305L43.4964 29.826C19.007 27.4409 12.4709 11.9346 12.4709 11.9346C12.4709 11.9346 12.5041 29.5818 42.7303 37.6305Z",
    fill: "url(#paint53_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 15.9167C15.3564 15.9167 20.4948 24.2712 30.2742 27.3203C30.2884 27.318 20.9143 26.4469 15.3564 15.9167Z",
    fill: "url(#paint54_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5027 24.0641C14.5811 24.2466 20.7172 38.3721 41.8018 32.9773V23.582C41.8018 23.582 26.7096 26.8658 14.5027 24.0641Z",
    fill: "url(#paint55_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5021 24.0646C14.5805 24.247 20.7166 38.3725 41.7881 32.9777V28.899C23.2101 32.8865 14.6196 24.1688 14.5021 24.0646Z",
    fill: "url(#paint56_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6289 29.9287C33.6289 29.9287 25.8087 31.2448 18.9807 27.0619C18.9807 27.0749 24.1506 29.7072 33.6289 29.9287Z",
    fill: "url(#paint57_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5791 36.7566C26.7227 36.8217 34.5299 40.314 41.8018 35.649V28.8989C41.8018 28.8989 33.9554 33.2513 26.5791 36.7566Z",
    fill: "url(#paint58_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5791 36.7561C26.7227 36.8212 34.5299 40.3135 41.8018 35.6354V32.6514C33.2243 37.577 26.7096 36.7822 26.5791 36.7561Z",
    fill: "url(#paint59_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5693 33.6942C39.5693 33.6942 35.261 36.8216 28.903 36.587C28.903 36.587 34.308 36.0398 39.5693 33.6942Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2766 18.6545C24.2766 18.6545 23.1047 21.2634 26.0239 24.5633C27.2586 25.959 31.0749 28.3122 33.6391 31.2901C37.1377 35.353 39.3724 40.0364 39.3724 40.0364L42.1445 28.1743L32.4009 22.9829L27.2134 20.216L24.2766 18.6545Z",
    fill: "url(#paint60_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.374 18.598C24.808 19.1733 23.8321 23.0316 29.3904 26.0223C31.5969 27.2095 32.6328 27.2407 32.6328 27.2407C32.6328 27.2407 33.7143 29.4298 35.4119 31.2006C37.1096 32.9715 39.3506 33.8285 39.3506 33.8285L38.4242 29.3887L34.294 24.0631L34.0436 23.6686L24.374 18.598Z",
    fill: "url(#paint61_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4301 23.1393C25.2996 23.9602 25.2735 24.6769 25.3257 25.3023C25.5999 29.0813 28.5504 29.9023 28.5504 29.9023C28.3154 34.2806 37.8981 38.3462 37.8981 38.3462L38.2114 37.4341L38.0678 37.2517L38.7598 32.9124L28.1196 25.1069L26.1351 22.6962L25.4301 23.1393Z",
    fill: "url(#paint62_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3131 25.3153C25.5872 29.0942 28.5378 29.9152 28.5378 29.9152L29.1514 29.2637L27.0495 25.2111L25.3131 25.3153Z",
    fill: "url(#paint63_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2123 37.4336C38.2123 37.4336 28.9299 33.4853 29.1518 29.2502C29.1518 29.2502 25.2613 28.1817 26.136 22.6957L39.0479 32.1691L38.2123 37.4336Z",
    fill: "url(#paint64_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2041 30.202C29.2041 30.202 30.3922 33.7856 36.1758 36.496C36.1888 36.496 30.0919 33.994 29.2041 30.202Z",
    fill: "url(#paint65_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4199 28.8854C28.4199 28.8854 26.096 28.1817 26.0699 24.2725C26.0699 24.2725 26.1613 27.6605 28.4199 28.8854Z",
    fill: "url(#paint66_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0479 32.1691L26.136 22.6957L25.431 23.1388L26.136 22.8911L39.0479 32.1691Z",
    fill: "url(#paint67_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4095 20.9307L43.0811 27.4461L42.4152 31.629L42.5458 31.7593L42.2847 32.5021C42.2847 32.5021 34.0989 27.381 33.0936 25.1918C32.0883 23.0026 29.0334 19.6015 29.0334 19.6015L29.2945 18.8588L31.4095 20.9307Z",
    fill: "url(#paint68_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4095 20.9307L43.0811 27.4461L42.4152 31.629L42.5458 31.7593L42.2847 32.5021C42.2847 32.5021 34.0989 27.381 33.0936 25.1918C32.0883 23.0026 29.0334 19.6015 29.0334 19.6015L29.2945 18.8588L31.4095 20.9307Z",
    fill: "#424242",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.532 31.7593C42.532 31.7593 34.3462 26.6382 33.3409 24.449C32.3357 22.2598 29.2807 18.8588 29.2807 18.8588L43.3545 26.7034L42.532 31.7593Z",
    fill: "url(#paint69_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2578 28.2146C37.2578 28.2146 34.0723 26.234 33.3412 24.4487C33.3412 24.4487 34.6337 26.26 37.2578 28.2146Z",
    fill: "url(#paint70_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.532 31.7593C42.532 31.7593 34.3462 26.6382 33.3409 24.449C32.3357 22.2598 29.2807 18.8588 29.2807 18.8588L43.3545 26.7034L42.532 31.7593Z",
    fill: "url(#paint71_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_578_447501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.1225 21.6623L51.6992 17.9243L51.79 20.4616L57.7934 23.8937L58.1225 21.6623Z",
    fill: "url(#paint72_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1225 21.6623L57.4416 21.9455L54.8882 20.4842L53.8214 19.8612L52.4709 19.091L51.6992 17.9243L53.3107 18.8531L56.4543 20.6882L58.1225 21.6623Z",
    fill: "url(#paint73_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7935 23.894L58.1226 21.6626L57.4417 21.9458L57.1807 23.5882L57.7935 23.894Z",
    fill: "url(#paint74_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6992 17.9243L52.4709 19.091L52.5276 20.8581L51.79 20.4616L51.6992 17.9243Z",
    fill: "url(#paint75_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4539 20.6886L56.0226 21.0963L54.8991 20.4733L53.8437 19.8956C53.8437 19.8956 53.8323 19.8843 53.8323 19.8616C53.7756 19.7484 53.56 19.3066 53.333 18.8535L56.4539 20.6886Z",
    fill: "url(#paint76_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5274 20.8587L52.4707 19.0917L57.4414 21.9462L57.1804 23.5886L52.5274 20.8587Z",
    fill: "url(#paint77_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8086 21.6962L44.2206 17.9583L44.1411 20.4955L38.1377 23.9277L37.8086 21.6962Z",
    fill: "url(#paint78_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8086 21.6962L38.4782 21.9794L41.0316 20.5182L42.1097 19.9066L43.4602 19.1249L44.2206 17.9583L42.6091 18.8871L39.4768 20.7221L37.8086 21.6962Z",
    fill: "url(#paint79_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1377 23.9277L37.8086 21.6962L38.4782 21.9793L38.7392 23.6218L38.1377 23.9277Z",
    fill: "url(#paint80_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2204 17.9583L43.4601 19.1249L43.4033 20.892L44.141 20.4955L44.2204 17.9583Z",
    fill: "url(#paint81_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4775 20.7219L39.9088 21.1297L41.0323 20.5067L42.0877 19.929C42.0877 19.929 42.0991 19.9177 42.0991 19.8951C42.1558 19.7818 42.3714 19.3401 42.5984 18.887L39.4775 20.7219Z",
    fill: "url(#paint82_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4038 20.8917L43.4606 19.1246L38.4785 21.9791L38.7395 23.6216L43.4038 20.8917Z",
    fill: "url(#paint83_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35.6289 37.8922L47.9762 44.3774V46.3823L35.6289 39.0876V37.8922Z",
    fill: "url(#paint84_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M60.2207 37.8922L47.8734 44.3774V46.3823L60.2207 39.0876V37.8922Z",
    fill: "url(#paint85_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3349 38.846V24.2678L47.9762 16.973L35.6289 24.2678V38.846L47.9762 46.1407L60.3349 38.846Z",
    fill: "url(#paint86_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6325 37.8488V25.2755L47.9761 18.9775L37.3311 25.2755V37.8488L47.9761 44.1354L58.6325 37.8488Z",
    fill: "url(#paint87_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6325 37.8488V25.2755L47.9761 18.9775L37.3311 25.2755V37.8488L47.9761 44.1354L58.6325 37.8488Z",
    fill: "url(#paint88_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1913 36.9995V26.114L47.9762 20.6769L38.7725 26.114V36.9995L47.9762 42.4365L57.1913 36.9995Z",
    fill: "url(#paint89_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6289 24.2676L37.3312 25.2757V37.8489L35.6289 38.8457V24.2676Z",
    fill: "url(#paint90_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3312 37.8492L47.9762 44.1359V46.1408L35.6289 38.846L37.3312 37.8492Z",
    fill: "url(#paint91_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.632 37.8492L60.3343 38.846L47.9756 46.1408V44.1359L58.632 37.8492Z",
    fill: "url(#paint92_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9756 16.973V18.978L58.632 25.2759L60.3343 24.2678L47.9756 16.973Z",
    fill: "url(#paint93_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9762 16.973V18.978L37.3312 25.2759L35.6289 24.2678L47.9762 16.973Z",
    fill: "url(#paint94_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9761 18.9775V20.6766L38.7723 26.1137L37.3311 25.2755L47.9761 18.9775Z",
    fill: "url(#paint95_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3311 25.276L38.7723 26.1142V36.9997L37.3311 37.8493V25.276Z",
    fill: "url(#paint96_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3311 37.8489L38.7723 36.9994L47.9761 42.4365V44.1356L37.3311 37.8489Z",
    fill: "url(#paint97_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6327 25.276L57.1914 26.1142V36.9997L58.6327 37.8493V25.276Z",
    fill: "url(#paint98_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1907 36.9994L58.632 37.8489L47.9756 44.1356V42.4365L57.1907 36.9994Z",
    fill: "url(#paint99_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6289 24.2674L37.3426 25.3888L37.3312 37.8488L37.683 25.3888L47.9762 18.9775L37.5695 25.049L35.6289 24.2674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.249 38.9474L47.7946 44.2373L47.9762 46.1402L48.1804 44.158L57.4069 38.5963L47.9875 43.9994L39.249 38.9474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9768 16.973L47.7952 18.8874L42.9834 22.025L47.9768 19.2045L53.6852 22.4101L48.1584 18.8534L47.9768 16.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9761 42.4365L47.9874 43.9996L37.3311 37.8489L38.7723 36.9994L47.9761 42.4365Z",
    fill: "url(#paint100_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9758 20.6769L38.7607 26.114V36.9995L47.9758 42.4365L57.1909 36.9995V26.114L47.9758 20.6769ZM56.0901 36.3425L47.9758 41.1339L39.8616 36.3425V26.7596L47.9758 21.9682L56.0901 26.7596V36.3425Z",
    fill: "url(#paint101_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6328 29.9199L60.2784 29.1836L60.3351 38.8457L58.6328 37.8489V29.9199Z",
    fill: "url(#paint102_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.297 29.9199L35.6401 29.1836L35.5947 38.8457L37.297 37.8489V29.9199Z",
    fill: "url(#paint103_linear_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9756 18.978L58.4163 25.4912L58.632 37.8492L58.7795 25.4346L60.3343 24.2679L58.6093 25.1514L47.9756 18.978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8389 26.5105V36.7163L47.9643 41.8249L39.1123 36.7163V26.5105L47.9643 21.4019L56.8389 26.5105Z",
    fill: "url(#paint104_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9643 21.4019L39.1123 26.5105V36.7277L47.9643 41.8362L56.8162 36.7277V26.5105L47.9643 21.4019ZM55.5452 35.9801L47.9756 40.341L40.4061 35.9801V27.2467L47.9756 22.8857L55.5452 27.2467V35.9801Z",
    fill: "url(#paint105_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9643 21.4019L39.1123 26.5105V36.7277L47.9643 41.8362L56.8162 36.7277V26.5105L47.9643 21.4019ZM55.5452 35.9801L47.9756 40.341L40.4061 35.9801V27.2467L47.9756 22.8857L55.5452 27.2467V35.9801Z",
    fill: "url(#paint106_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1123 26.5103L40.3947 27.2465V35.9798L39.1123 36.7161V26.5103Z",
    fill: "url(#paint107_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1123 36.7164L40.3947 35.9801L47.9643 40.3411V41.825L39.1123 36.7164Z",
    fill: "url(#paint108_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9639 40.3411V41.825L56.8385 36.7164L55.5448 35.9801L47.9639 40.3411Z",
    fill: "url(#paint109_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5459 27.247L56.8396 26.5107V36.7166L55.5459 35.9803V27.247Z",
    fill: "url(#paint110_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5459 27.247L56.8396 26.5107V36.7166L55.5459 35.9803V27.247Z",
    fill: "url(#paint111_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9643 21.4019V22.8857L40.3947 27.2467L39.1123 26.5105L47.9643 21.4019Z",
    fill: "url(#paint112_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9639 22.8856L55.4313 27.2806L55.5448 35.9799L55.7264 27.2353L56.8385 26.5103L55.6015 27.0314L47.9639 22.8856Z",
    fill: "url(#paint113_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3945 35.9801L47.9527 40.1712L55.545 35.9801L48.1116 40.3864L47.9641 41.825L47.8165 40.3524L40.3945 35.9801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1123 26.5103L40.2585 27.3712L40.3947 35.9799L40.5649 27.3372L47.9643 22.8856L40.4061 27.0654L39.1123 26.5103Z",
    fill: "url(#paint114_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8389 26.5105V26.737C43.1297 29.0591 39.1123 36.7277 39.1123 36.7277V26.5105L47.9643 21.4019L56.8389 26.5105Z",
    fill: "url(#paint115_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8389 26.5105V26.737C43.1297 29.0591 39.1123 36.7277 39.1123 36.7277V26.5105L47.9643 21.4019L56.8389 26.5105Z",
    fill: "white",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.8213 28.3344C45.1226 28.3455 45.3794 28.3678 45.5914 28.379C45.8035 28.3901 45.9709 28.3902 46.0937 28.3902C46.2499 28.3902 46.5513 28.379 47.0201 28.3566C47.1987 28.3455 47.3215 28.3455 47.4107 28.3455V28.7138C47.154 28.725 46.9866 28.7585 46.9085 28.8031C46.8304 28.8477 46.7969 28.9259 46.7969 29.0375C46.7969 29.0933 46.808 29.1491 46.8192 29.2273C46.8303 29.3054 46.8638 29.3835 46.8973 29.484L48.3595 33.6919L49.7323 29.4951C49.777 29.3947 49.7993 29.3165 49.8105 29.2607C49.8216 29.2049 49.8216 29.1491 49.8216 29.0821C49.8216 28.9482 49.777 28.8589 49.6654 28.8031C49.5537 28.7473 49.3863 28.7138 49.1408 28.7138V28.3455C49.3752 28.3567 49.5538 28.3678 49.6989 28.379C49.844 28.3901 49.9667 28.3902 50.0672 28.3902C50.1453 28.3902 50.2458 28.3901 50.3797 28.379C50.5137 28.3678 50.8596 28.3678 51.094 28.3455V28.7138C50.8708 28.7362 50.7257 28.7696 50.6364 28.8254C50.5583 28.8813 50.4913 28.9817 50.4467 29.1268L48.951 33.5021C48.8617 33.7588 48.7613 34.0267 48.6608 34.3057C48.5492 34.5848 48.4488 34.875 48.326 35.1763L47.701 35.1205L45.5691 29.3165L45.5579 29.2831C45.424 28.9036 45.1784 28.7027 44.8324 28.7027L44.8213 28.3344Z",
    fill: "url(#paint116_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0332 28.3234C45.3346 28.3345 45.5913 28.3568 45.8034 28.368C46.0154 28.3792 46.1829 28.3792 46.3056 28.3792C46.4619 28.3792 46.7632 28.368 47.232 28.3457C47.4106 28.3345 47.5334 28.3345 47.6227 28.3345V28.7028C47.3659 28.714 47.1985 28.7475 47.1204 28.781C47.0423 28.8256 47.0088 28.9038 47.0088 29.0154C47.0088 29.0712 47.02 29.127 47.0311 29.1939C47.0423 29.2609 47.0758 29.3391 47.1093 29.4395L48.5714 33.5581L49.9443 29.4507C49.9889 29.3502 50.0112 29.2721 50.0224 29.2163C50.0335 29.1605 50.0336 29.1047 50.0336 29.0489C50.0336 28.9261 49.9889 28.8368 49.8773 28.781C49.7657 28.7252 49.5982 28.7028 49.3527 28.7028V28.3345C49.5871 28.3457 49.7657 28.3568 49.9108 28.368C50.0559 28.3792 50.1786 28.3792 50.2791 28.3792C50.3572 28.3792 50.4577 28.3792 50.5916 28.368C50.7256 28.3568 50.9041 28.3569 51.1385 28.3345V28.7028C50.9153 28.7252 50.7702 28.7587 50.6809 28.8145C50.6028 28.8703 50.5358 28.9596 50.4912 29.1047L48.9955 33.3907C48.9062 33.6474 48.8058 33.9153 48.7053 34.1831C48.5937 34.451 48.4933 34.7412 48.3705 35.0426L47.9129 34.9868L45.781 29.3056L45.7699 29.2721C45.6359 28.9038 45.3904 28.714 45.0444 28.714L45.0332 28.3234Z",
    fill: "url(#paint117_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4491 33.2787L47.0874 29.428C47.0539 29.3275 47.0315 29.2494 47.0092 29.1824C46.9981 29.1155 46.9869 29.0485 46.9869 29.0038C46.9869 28.9369 46.9981 28.8811 47.0316 28.8364C46.9646 28.8476 46.9199 28.8699 46.8753 28.8811C46.7972 28.9257 46.7637 29.0038 46.7637 29.1155C46.7637 29.1713 46.7748 29.2271 46.786 29.2941C46.7972 29.361 46.8307 29.4391 46.8641 29.5396L48.3263 33.6582L48.4491 33.2787Z",
    fill: "url(#paint118_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5694 28.4684C45.7814 28.4795 45.9489 28.4796 46.0716 28.4796C46.2279 28.4796 46.5293 28.4684 46.998 28.4461C47.1766 28.4349 47.2994 28.4349 47.3887 28.4349V28.7028C47.4557 28.6916 47.5338 28.6916 47.6119 28.6916V28.3233C47.5226 28.3233 47.3887 28.3345 47.2213 28.3345C46.7636 28.3568 46.4511 28.3679 46.2949 28.3679C46.1721 28.3679 46.0047 28.3568 45.7926 28.3568C45.5805 28.3456 45.3238 28.3345 45.0225 28.3121V28.4349C45.2345 28.4572 45.4131 28.4684 45.5694 28.4684Z",
    fill: "url(#paint119_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.569 28.3566C50.4351 28.3678 50.3346 28.3678 50.2565 28.3678C50.156 28.3678 50.0333 28.3678 49.8882 28.3566C49.7431 28.3455 49.5533 28.3455 49.3301 28.3232V28.446C49.464 28.4571 49.5645 28.4571 49.6649 28.4571C49.81 28.4683 49.9328 28.4683 50.0333 28.4683C50.1114 28.4683 50.2118 28.4683 50.3458 28.4571C50.4797 28.446 50.6583 28.4459 50.8927 28.4236V28.7138C50.9597 28.7027 51.0378 28.6915 51.1159 28.6804V28.312C50.8815 28.3343 50.6918 28.3455 50.569 28.3566Z",
    fill: "url(#paint120_radial_578_447501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4359 28.9035C50.3577 28.9593 50.2907 29.0485 50.2461 29.1936L48.7505 33.4797C48.6612 33.7364 48.5607 34.0042 48.4602 34.2721C48.371 34.5065 48.2817 34.752 48.1924 34.9976L48.371 35.0088C48.4826 34.7074 48.5942 34.4284 48.7058 34.1494C48.8174 33.8815 48.9067 33.6136 48.996 33.3569L50.4917 29.0709C50.5251 28.9593 50.5698 28.8811 50.6367 28.8253C50.5363 28.8588 50.4805 28.8811 50.4359 28.9035Z",
    fill: "url(#paint121_radial_578_447501)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.879 43.3946C55.8159 43.4856 55.816 43.606 55.8792 43.6969C56.0756 43.9793 56.292 44.2506 56.5239 44.5064C56.5383 44.5207 56.5527 44.5422 56.5742 44.5566C56.6532 44.6426 56.7395 44.7286 56.8257 44.8146C57.0268 45.0154 57.228 45.2017 57.4507 45.3738C57.6126 45.5075 57.7788 45.6325 57.9527 45.7523C58.044 45.8151 58.1644 45.8147 58.2539 45.7493C58.5977 45.4977 59.0722 45.0874 59.4773 44.6771C59.8044 44.3457 60.1374 43.921 60.3081 43.6956C60.379 43.602 60.3801 43.4742 60.3122 43.3785C60.2247 43.2553 60.1048 43.0893 60.0225 42.9867C59.8214 42.7358 59.6058 42.4921 59.3831 42.2627C59.261 42.1408 59.1389 42.0261 59.0096 41.9114C58.7689 41.7013 58.5182 41.5063 58.2575 41.3221C58.1655 41.2572 58.0429 41.2565 57.9502 41.3205C57.7676 41.4465 57.5904 41.5778 57.4219 41.7179C57.2136 41.8899 57.0196 42.0691 56.8328 42.2555C56.4751 42.6188 56.1572 42.9935 55.879 43.3946Z",
    fill: "url(#paint122_linear_578_447501)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3723 43.5432C56.5381 43.7943 56.7254 44.0347 56.9287 44.259C56.9394 44.2697 56.9501 44.2857 56.9662 44.2964C57.025 44.3605 57.0892 44.4246 57.1534 44.4887C57.3032 44.6383 57.4531 44.7772 57.6189 44.9054C57.7741 45.0336 57.9346 45.1511 58.1058 45.2633C58.3626 45.0924 58.6034 44.9054 58.8335 44.7024C59.2026 44.3712 59.529 43.9973 59.8072 43.5806C59.8179 43.5646 59.8286 43.5539 59.834 43.5379C59.7377 43.399 59.6414 43.2601 59.5344 43.1266C59.3845 42.9396 59.224 42.758 59.0582 42.587C58.9672 42.4962 58.8763 42.4108 58.78 42.3253C58.5659 42.1383 58.3412 41.9674 58.1058 41.8071C57.9292 41.9246 57.758 42.0475 57.5975 42.1811C57.4424 42.3093 57.2979 42.4428 57.1588 42.5817C56.8592 42.8862 56.597 43.2013 56.3723 43.5432Z",
    fill: "#B9F2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3724 43.5436H58.1006V41.8235C57.7582 42.0478 57.4371 42.3096 57.1482 42.5981C56.8593 42.8865 56.5971 43.2017 56.3724 43.5436Z",
    fill: "url(#paint123_radial_578_447501)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1009 41.8235V43.5489H59.8291C59.6044 43.207 59.3422 42.8865 59.0533 42.5981C58.759 42.3096 58.4433 42.0478 58.1009 41.8235Z",
    fill: "url(#paint124_radial_578_447501)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1009 43.5436V45.269C58.7858 44.8149 59.3743 44.2273 59.8291 43.5436H58.1009Z",
    fill: "url(#paint125_radial_578_447501)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3724 43.5436C56.5971 43.8855 56.8593 44.206 57.1482 44.4944C57.4371 44.7829 57.7582 45.0446 58.1006 45.269V43.5436H56.3724Z",
    fill: "url(#paint126_radial_578_447501)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3727 43.5432C56.5974 43.885 56.8596 44.2056 57.1485 44.494C57.4374 44.7825 57.7584 45.0442 58.1009 45.2686C58.3577 45.0976 58.4486 45.0389 58.6787 44.8359L57.5926 42.197C57.4374 42.3252 57.293 42.4588 57.1538 42.5977C56.8596 42.8861 56.5974 43.2013 56.3727 43.5432Z",
    fill: "url(#paint127_radial_578_447501)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9607 44.3014C57.0195 44.3655 57.0838 44.4296 57.148 44.4937C57.4369 44.7821 57.7579 45.0439 58.1003 45.2682C58.3571 45.0973 58.5979 44.9103 58.828 44.7074C59.1972 44.3762 59.5235 44.0022 59.8018 43.5856C59.0795 43.7992 58.0201 44.093 56.9607 44.3014Z",
    fill: "url(#paint128_radial_578_447501)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.928 44.2591C56.9387 44.2698 56.9494 44.2858 56.9654 44.2965C57.0243 44.3606 57.0885 44.4247 57.1527 44.4888C57.3025 44.6384 57.4523 44.7773 57.6182 44.9055C58.0248 44.1843 58.4743 43.319 58.5117 42.9824C58.5064 42.9878 57.6075 43.7303 56.928 44.2591Z",
    fill: "url(#paint129_radial_578_447501)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1007 43.5434L59.5293 43.1321C59.3795 42.9451 59.219 42.7635 59.0531 42.5926C58.9622 42.5017 58.8712 42.4163 58.7749 42.3308L58.1007 43.5434Z",
    fill: "url(#paint130_radial_578_447501)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0996 44.6815C58.5491 44.3824 58.9396 43.9978 59.2393 43.5437C58.9396 43.095 58.5544 42.705 58.0996 42.4059C57.6502 42.705 57.2596 43.0896 56.96 43.5437C57.2596 43.9978 57.6448 44.3824 58.0996 44.6815Z",
    fill: "url(#paint131_radial_578_447501)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5285 43.212C59.3787 43.0251 59.2182 42.8434 59.0523 42.6725C58.9614 42.5817 58.8704 42.4962 58.7741 42.4108C58.5601 42.2238 58.3354 42.0529 58.0999 41.8926C57.9234 42.0101 57.7522 42.133 57.5917 42.2665C57.4365 42.3947 57.292 42.5283 57.1529 42.6672C56.8747 42.9449 56.6232 43.2494 56.4039 43.5753C56.3932 43.5593 56.3878 43.5486 56.3771 43.5325C56.6018 43.1907 56.864 42.8702 57.1529 42.5817C57.292 42.4428 57.4418 42.3093 57.5917 42.1811C57.7522 42.0475 57.9234 41.9193 58.0999 41.8071C58.3354 41.962 58.5601 42.1383 58.7741 42.3253C58.8704 42.4108 58.9614 42.4962 59.0523 42.587C59.2235 42.758 59.384 42.9343 59.5285 43.1266C59.6355 43.2601 59.7318 43.399 59.8281 43.5379C59.8174 43.5539 59.8121 43.5646 59.8014 43.5806C59.7104 43.4578 59.6195 43.3349 59.5285 43.212Z",
    fill: "url(#paint132_radial_578_447501)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9287 44.179C56.9394 44.1897 56.9501 44.2057 56.9662 44.2164C57.025 44.2805 57.0892 44.3446 57.1534 44.4087C57.3032 44.5583 57.4531 44.6972 57.6189 44.8254C57.7741 44.9536 57.9346 45.0711 58.1058 45.1833C58.3626 45.0124 58.6034 44.8254 58.8335 44.6224C59.2026 44.2912 59.529 43.9173 59.8072 43.5006C59.8179 43.5166 59.8286 43.5273 59.834 43.5433C59.8233 43.5594 59.8126 43.5701 59.8072 43.5861C59.529 43.9974 59.2026 44.3713 58.8335 44.7079C58.6087 44.9109 58.3626 45.1032 58.1058 45.2688C57.9399 45.1566 57.7741 45.0391 57.6189 44.9109C57.4584 44.7773 57.3032 44.6384 57.1534 44.4942C57.0892 44.4301 57.0304 44.366 56.9662 44.3019C56.9555 44.2912 56.9448 44.2752 56.9287 44.2645C56.7254 44.0401 56.5435 43.7998 56.3723 43.5487C56.383 43.5327 56.3937 43.522 56.399 43.506C56.5595 43.741 56.7361 43.9654 56.9287 44.179Z",
    fill: "url(#paint133_radial_578_447501)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0526 42.6724C59.2185 42.8433 59.379 43.0249 59.5288 43.2119L59.7764 43.5463C59.505 43.9446 59.1891 44.3033 58.8335 44.6223C58.6034 44.8253 58.3626 45.0123 58.1058 45.1832C57.9346 45.0711 57.7741 44.9535 57.6189 44.8253C57.4531 44.6971 57.3032 44.5582 57.1534 44.4087L57.1534 44.4087C57.0892 44.3446 57.025 44.2805 56.9662 44.2164C56.9552 44.2091 56.9467 44.1993 56.939 44.1904C56.9355 44.1863 56.9321 44.1823 56.9287 44.179C56.7465 43.9769 56.5787 43.7652 56.4253 43.544C56.6396 43.2299 56.8839 42.936 57.1532 42.667C57.2923 42.5282 57.4368 42.3946 57.592 42.2664C57.7525 42.1329 57.9237 42.01 58.1002 41.8925C58.3357 42.0527 58.5604 42.2237 58.7744 42.4106C58.8707 42.4961 58.9617 42.5816 59.0526 42.6724ZM56.3805 43.5371C56.3795 43.5356 56.3785 43.534 56.3774 43.5324C56.6021 43.1905 56.8643 42.87 57.1532 42.5816C57.2923 42.4427 57.4421 42.3091 57.592 42.1809C57.7525 42.0474 57.9237 41.9192 58.1002 41.807C58.3357 41.9619 58.5604 42.1382 58.7744 42.3252C58.8707 42.4106 58.9617 42.4961 59.0526 42.5869C59.2238 42.7579 59.3843 42.9341 59.5288 43.1264C59.6271 43.2491 59.7164 43.3764 59.805 43.5039C59.8057 43.5028 59.8065 43.5017 59.8072 43.5006C59.8104 43.5053 59.8136 43.5096 59.8167 43.5138C59.8238 43.5234 59.8302 43.532 59.834 43.5433C59.8308 43.5481 59.8276 43.5524 59.8245 43.5565C59.8174 43.5662 59.811 43.5748 59.8072 43.586C59.529 43.9973 59.2026 44.3713 58.8335 44.7078C58.6087 44.9108 58.3626 45.1031 58.1058 45.2687C57.9399 45.1565 57.7741 45.039 57.6189 44.9108C57.4584 44.7773 57.3032 44.6384 57.1534 44.4941C57.1213 44.4621 57.0906 44.43 57.0598 44.398C57.029 44.3659 56.9983 44.3339 56.9662 44.3018C56.9628 44.2984 56.9594 44.2945 56.9558 44.2904C56.9482 44.2815 56.9397 44.2717 56.9287 44.2644C56.7254 44.0401 56.5435 43.7997 56.3723 43.5486C56.375 43.5445 56.3778 43.5407 56.3805 43.5371Z",
    fill: "url(#paint134_radial_578_447501)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1006 42.4103C58.1006 42.4103 57.4264 42.8323 56.9609 43.5481C56.9609 43.5427 57.2927 42.8056 58.1006 42.4103Z",
    fill: "url(#paint135_radial_578_447501)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2344 43.5438C59.2344 43.5438 58.8331 44.2489 58.1536 44.6709L58.1001 45.1838L58.0626 44.6603C58.0626 44.6603 57.5543 44.4466 56.9605 43.5438C56.9605 43.5438 57.7095 44.5481 58.1108 44.6015C58.1108 44.6068 58.5763 44.4252 59.2344 43.5438Z",
    fill: "url(#paint136_radial_578_447501)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0947 44.6762C58.0947 44.6762 57.3885 44.2755 56.9658 43.5971L56.4522 43.5437L56.9765 43.5063C56.9765 43.5063 57.1905 42.9988 58.0947 42.4059C58.0947 42.4059 57.0889 43.1537 57.0353 43.5544C57.03 43.5544 57.2119 44.0191 58.0947 44.6762Z",
    fill: "url(#paint137_radial_578_447501)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1221 42.4059C58.1221 42.4059 58.8283 42.8065 59.251 43.4849L59.7646 43.5384L59.2403 43.5757C59.2403 43.5757 59.0263 44.0832 58.1221 44.6762C58.1221 44.6762 59.128 43.9283 59.1815 43.5277C59.1868 43.5277 59.0049 43.0629 58.1221 42.4059Z",
    fill: "url(#paint138_radial_578_447501)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9605 43.5377C56.9605 43.5377 57.3617 42.8325 58.0412 42.4105L58.0947 41.8977L58.1322 42.4212C58.1322 42.4212 58.6405 42.6349 59.2344 43.5377C59.2344 43.5377 58.4853 42.5334 58.084 42.48C58.084 42.4746 57.6186 42.6562 56.9605 43.5377Z",
    fill: "url(#paint139_radial_578_447501)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8077 46.5339C50.7446 46.6249 50.7447 46.7452 50.8079 46.8361C51.0044 47.1186 51.2207 47.3899 51.4527 47.6457C51.467 47.66 51.4814 47.6815 51.5029 47.6959C51.582 47.7819 51.6682 47.8679 51.7544 47.9539C51.9555 48.1546 52.1567 48.341 52.3794 48.5131C52.5413 48.6468 52.7075 48.7718 52.8814 48.8915C52.9727 48.9544 53.0931 48.954 53.1826 48.8886C53.5264 48.637 54.0009 48.2267 54.406 47.8164C54.7331 47.485 55.0662 47.0603 55.2368 46.8348C55.3077 46.7413 55.3089 46.6135 55.2409 46.5178C55.1534 46.3946 55.0335 46.2286 54.9512 46.126C54.7501 45.8751 54.5345 45.6313 54.3118 45.4019C54.1897 45.2801 54.0676 45.1654 53.9383 45.0507C53.6977 44.8406 53.4469 44.6456 53.1862 44.4614C53.0942 44.3965 52.9716 44.3958 52.8789 44.4598C52.6963 44.5857 52.5191 44.7171 52.3506 44.8571C52.1423 45.0292 51.9483 45.2084 51.7616 45.3948C51.4038 45.7581 51.0859 46.1328 50.8077 46.5339Z",
    fill: "url(#paint140_linear_578_447501)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M51.301 46.6825C51.4668 46.9336 51.6541 47.174 51.8574 47.3983C51.8681 47.409 51.8788 47.425 51.8949 47.4357C51.9537 47.4998 52.0179 47.5639 52.0821 47.628C52.232 47.7776 52.3818 47.9165 52.5476 48.0447C52.7028 48.1729 52.8633 48.2904 53.0345 48.4026C53.2913 48.2316 53.5321 48.0447 53.7622 47.8417C54.1313 47.5105 54.4577 47.1366 54.7359 46.7199C54.7466 46.7039 54.7573 46.6932 54.7627 46.6772C54.6664 46.5383 54.5701 46.3994 54.4631 46.2658C54.3133 46.0789 54.1527 45.8973 53.9869 45.7263C53.8959 45.6355 53.805 45.55 53.7087 45.4646C53.4946 45.2776 53.2699 45.1067 53.0345 44.9464C52.858 45.0639 52.6867 45.1868 52.5262 45.3203C52.3711 45.4485 52.2266 45.5821 52.0875 45.721C51.7879 46.0255 51.5257 46.3406 51.301 46.6825Z",
    fill: "#B9F2FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3011 46.6828H53.0293V44.9628C52.6869 45.1871 52.3658 45.4489 52.0769 45.7373C51.788 46.0258 51.5258 46.341 51.3011 46.6828Z",
    fill: "url(#paint141_radial_578_447501)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0296 44.9628V46.6882H54.7578C54.5331 46.3463 54.2709 46.0258 53.982 45.7373C53.6877 45.4489 53.3721 45.1871 53.0296 44.9628Z",
    fill: "url(#paint142_radial_578_447501)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0296 46.6829V48.4083C53.7145 47.9542 54.303 47.3666 54.7578 46.6829H53.0296Z",
    fill: "url(#paint143_radial_578_447501)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3011 46.6829C51.5258 47.0247 51.788 47.3452 52.0769 47.6337C52.3658 47.9222 52.6869 48.1839 53.0293 48.4083V46.6829H51.3011Z",
    fill: "url(#paint144_radial_578_447501)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3014 46.6824C51.5261 47.0243 51.7883 47.3448 52.0772 47.6333C52.3661 47.9218 52.6872 48.1835 53.0296 48.4079C53.2864 48.2369 53.3774 48.1782 53.6074 47.9752L52.5213 45.3363C52.3661 45.4645 52.2217 45.5981 52.0826 45.7369C51.7883 46.0254 51.5261 46.3406 51.3014 46.6824Z",
    fill: "url(#paint145_radial_578_447501)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8894 47.4407C51.9483 47.5048 52.0125 47.5689 52.0767 47.633C52.3656 47.9214 52.6866 48.1832 53.029 48.4075C53.2859 48.2366 53.5266 48.0496 53.7567 47.8466C54.1259 47.5154 54.4522 47.1415 54.7305 46.7249C54.0082 46.9385 52.9488 47.2323 51.8894 47.4407Z",
    fill: "url(#paint146_radial_578_447501)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8567 47.3984C51.8674 47.4091 51.8781 47.4251 51.8942 47.4358C51.953 47.4999 52.0172 47.564 52.0814 47.6281C52.2312 47.7777 52.381 47.9166 52.5469 48.0448C52.9535 47.3236 53.403 46.4582 53.4404 46.1217C53.4351 46.127 52.5362 46.8696 51.8567 47.3984Z",
    fill: "url(#paint147_radial_578_447501)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0294 46.6827L54.458 46.2714C54.3082 46.0844 54.1477 45.9028 53.9818 45.7318C53.8909 45.641 53.7999 45.5556 53.7036 45.4701L53.0294 46.6827Z",
    fill: "url(#paint148_radial_578_447501)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0283 47.8208C53.4778 47.5216 53.8683 47.137 54.168 46.683C53.8683 46.2343 53.4831 45.8443 53.0283 45.5452C52.5789 45.8443 52.1883 46.2289 51.8887 46.683C52.1883 47.137 52.5735 47.5216 53.0283 47.8208Z",
    fill: "url(#paint149_radial_578_447501)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4572 46.3513C54.3074 46.1643 54.1469 45.9827 53.981 45.8118C53.8901 45.721 53.7991 45.6355 53.7028 45.55C53.4888 45.3631 53.2641 45.1921 53.0287 45.0319C52.8521 45.1494 52.6809 45.2723 52.5204 45.4058C52.3652 45.534 52.2207 45.6676 52.0816 45.8064C51.8034 46.0842 51.5519 46.3887 51.3326 46.7146C51.3219 46.6985 51.3165 46.6878 51.3058 46.6718C51.5305 46.3299 51.7927 46.0094 52.0816 45.721C52.2207 45.5821 52.3706 45.4485 52.5204 45.3203C52.6809 45.1868 52.8521 45.0586 53.0287 44.9464C53.2641 45.1013 53.4888 45.2776 53.7028 45.4646C53.7991 45.55 53.8901 45.6355 53.981 45.7263C54.1522 45.8973 54.3128 46.0735 54.4572 46.2658C54.5642 46.3994 54.6605 46.5383 54.7568 46.6772C54.7461 46.6932 54.7408 46.7039 54.7301 46.7199C54.6391 46.597 54.5482 46.4742 54.4572 46.3513Z",
    fill: "url(#paint150_radial_578_447501)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8574 47.3183C51.8681 47.329 51.8788 47.345 51.8949 47.3557C51.9537 47.4198 52.0179 47.4839 52.0821 47.548C52.232 47.6976 52.3818 47.8365 52.5476 47.9647C52.7028 48.0929 52.8633 48.2104 53.0345 48.3226C53.2913 48.1516 53.5321 47.9647 53.7622 47.7617C54.1313 47.4305 54.4577 47.0566 54.7359 46.6399C54.7466 46.6559 54.7573 46.6666 54.7627 46.6826C54.752 46.6987 54.7413 46.7093 54.7359 46.7254C54.4577 47.1367 54.1313 47.5106 53.7622 47.8471C53.5375 48.0501 53.2913 48.2424 53.0345 48.408C52.8687 48.2959 52.7028 48.1783 52.5476 48.0501C52.3871 47.9166 52.232 47.7777 52.0821 47.6335C52.0179 47.5694 51.9591 47.5053 51.8949 47.4412C51.8842 47.4305 51.8735 47.4145 51.8574 47.4038C51.6541 47.1794 51.4722 46.939 51.301 46.688C51.3117 46.6719 51.3224 46.6613 51.3277 46.6452C51.4882 46.8803 51.6648 47.1046 51.8574 47.3183Z",
    fill: "url(#paint151_radial_578_447501)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9813 45.8117C54.1472 45.9826 54.3077 46.1642 54.4575 46.3512L54.7051 46.6856C54.4337 47.0839 54.1178 47.4426 53.7622 47.7616C53.5321 47.9646 53.2913 48.1516 53.0345 48.3225C52.8633 48.2103 52.7028 48.0928 52.5476 47.9646C52.3818 47.8364 52.232 47.6975 52.0821 47.5479L52.0821 47.5479C52.0179 47.4838 51.9537 47.4197 51.8949 47.3556C51.8839 47.3483 51.8754 47.3385 51.8678 47.3297C51.8642 47.3256 51.8608 47.3216 51.8574 47.3182C51.6752 47.1162 51.5074 46.9045 51.354 46.6833C51.5683 46.3692 51.8126 46.0752 52.0819 45.8063C52.221 45.6674 52.3655 45.5339 52.5207 45.4057C52.6812 45.2721 52.8524 45.1493 53.029 45.0318C53.2644 45.192 53.4891 45.363 53.7031 45.5499C53.7994 45.6354 53.8904 45.7209 53.9813 45.8117ZM51.3092 46.6764C51.3082 46.6749 51.3072 46.6733 51.3061 46.6717C51.5308 46.3298 51.793 46.0093 52.0819 45.7209C52.221 45.582 52.3709 45.4484 52.5207 45.3202C52.6812 45.1867 52.8524 45.0585 53.029 44.9463C53.2644 45.1012 53.4891 45.2775 53.7031 45.4644C53.7994 45.5499 53.8904 45.6354 53.9813 45.7262C54.1525 45.8971 54.3131 46.0734 54.4575 46.2657C54.5558 46.3884 54.6451 46.5156 54.7337 46.6432C54.7344 46.6421 54.7352 46.641 54.7359 46.6398C54.7391 46.6446 54.7423 46.6489 54.7454 46.653C54.7526 46.6627 54.7589 46.6713 54.7627 46.6826C54.7595 46.6874 54.7563 46.6917 54.7533 46.6958C54.7461 46.7054 54.7397 46.7141 54.7359 46.7253C54.4577 47.1366 54.1313 47.5106 53.7622 47.8471C53.5375 48.0501 53.2913 48.2424 53.0345 48.408C52.8687 48.2958 52.7028 48.1783 52.5476 48.0501C52.3871 47.9165 52.232 47.7776 52.0821 47.6334C52.05 47.6014 52.0193 47.5693 51.9885 47.5373C51.9577 47.5052 51.927 47.4732 51.8949 47.4411C51.8915 47.4377 51.8881 47.4338 51.8845 47.4297C51.8769 47.4208 51.8684 47.411 51.8574 47.4037C51.6541 47.1794 51.4722 46.939 51.301 46.6879C51.3037 46.6838 51.3065 46.68 51.3092 46.6764Z",
    fill: "url(#paint152_radial_578_447501)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0293 45.5496C53.0293 45.5496 52.3551 45.9716 51.8897 46.6874C51.8897 46.682 52.2214 45.9449 53.0293 45.5496Z",
    fill: "url(#paint153_radial_578_447501)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1631 46.6831C54.1631 46.6831 53.7618 47.3882 53.0823 47.8102L53.0288 48.323L52.9913 47.7995C52.9913 47.7995 52.4831 47.5859 51.8892 46.6831C51.8892 46.6831 52.6382 47.6874 53.0395 47.7408C53.0395 47.7461 53.505 47.5645 54.1631 46.6831Z",
    fill: "url(#paint154_radial_578_447501)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0234 47.8154C53.0234 47.8154 52.3172 47.4148 51.8945 46.7364L51.3809 46.683L51.9052 46.6456C51.9052 46.6456 52.1192 46.1381 53.0234 45.5452C53.0234 45.5452 52.0176 46.293 51.9641 46.6937C51.9587 46.6937 52.1406 47.1584 53.0234 47.8154Z",
    fill: "url(#paint155_radial_578_447501)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0508 45.5452C53.0508 45.5452 53.757 45.9458 54.1797 46.6242L54.6934 46.6776L54.169 46.715C54.169 46.715 53.955 47.2225 53.0508 47.8154C53.0508 47.8154 54.0567 47.0676 54.1102 46.667C54.1155 46.667 53.9336 46.2022 53.0508 45.5452Z",
    fill: "url(#paint156_radial_578_447501)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8892 46.6769C51.8892 46.6769 52.2904 45.9718 52.9699 45.5498L53.0234 45.037L53.0609 45.5605C53.0609 45.5605 53.5692 45.7742 54.1631 46.6769C54.1631 46.6769 53.414 45.6727 53.0127 45.6192C53.0127 45.6139 52.5473 45.7955 51.8892 46.6769Z",
    fill: "url(#paint157_radial_578_447501)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7364 49.2294C45.6733 49.3204 45.6734 49.4408 45.7367 49.5317C45.9331 49.8141 46.1494 50.0855 46.3814 50.3412C46.3957 50.3556 46.4101 50.3771 46.4316 50.3914C46.5107 50.4774 46.5969 50.5635 46.6831 50.6495C46.8842 50.8502 47.0854 51.0366 47.3081 51.2086C47.47 51.3423 47.6362 51.4674 47.8101 51.5871C47.9014 51.6499 48.0218 51.6496 48.1113 51.5842C48.4551 51.3326 48.9297 50.9223 49.3347 50.512C49.6618 50.1806 49.9949 49.7558 50.1655 49.5304C50.2364 49.4368 50.2376 49.309 50.1696 49.2133C50.0821 49.0901 49.9622 48.9241 49.8799 48.8215C49.6788 48.5706 49.4633 48.3269 49.2406 48.0975C49.1184 47.9756 48.9963 47.8609 48.867 47.7462C48.6264 47.5361 48.3757 47.3411 48.1149 47.157C48.0229 47.092 47.9003 47.0914 47.8076 47.1553C47.625 47.2813 47.4478 47.4126 47.2794 47.5527C47.071 47.7247 46.8771 47.904 46.6903 48.0903C46.3325 48.4537 46.0146 48.8283 45.7364 49.2294Z",
    fill: "url(#paint158_linear_578_447501)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2297 49.3781C46.3956 49.6291 46.5828 49.8695 46.7861 50.0939C46.7968 50.1046 46.8075 50.1206 46.8236 50.1313C46.8824 50.1954 46.9466 50.2595 47.0109 50.3236C47.1607 50.4731 47.3105 50.612 47.4763 50.7402C47.6315 50.8684 47.792 50.986 47.9632 51.0981C48.22 50.9272 48.4608 50.7402 48.6909 50.5372C49.0601 50.206 49.3864 49.8321 49.6647 49.4155C49.6754 49.3994 49.6861 49.3887 49.6914 49.3727C49.5951 49.2338 49.4988 49.0949 49.3918 48.9614C49.242 48.7744 49.0815 48.5928 48.9156 48.4219C48.8246 48.3311 48.7337 48.2456 48.6374 48.1601C48.4234 47.9732 48.1986 47.8022 47.9632 47.642C47.7867 47.7595 47.6154 47.8824 47.4549 48.0159C47.2998 48.1441 47.1553 48.2776 47.0162 48.4165C46.7166 48.721 46.4544 49.0362 46.2297 49.3781Z",
    fill: "#B9F2FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2298 49.3784H47.958V47.6583C47.6156 47.8827 47.2946 48.1444 47.0056 48.4329C46.7167 48.7214 46.4545 49.0365 46.2298 49.3784Z",
    fill: "url(#paint159_radial_578_447501)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9583 47.6583V49.3837H49.6865C49.4618 49.0419 49.1996 48.7214 48.9107 48.4329C48.6164 48.1444 48.3008 47.8827 47.9583 47.6583Z",
    fill: "url(#paint160_radial_578_447501)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9583 49.3784V51.1038C48.6432 50.6498 49.2317 50.0622 49.6865 49.3784H47.9583Z",
    fill: "url(#paint161_radial_578_447501)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2298 49.3784C46.4545 49.7203 46.7167 50.0408 47.0056 50.3293C47.2946 50.6177 47.6156 50.8795 47.958 51.1038V49.3784H46.2298Z",
    fill: "url(#paint162_radial_578_447501)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2301 49.378C46.4548 49.7199 46.717 50.0404 47.0059 50.3289C47.2948 50.6173 47.6159 50.8791 47.9583 51.1034C48.2151 50.9325 48.3061 50.8737 48.5361 50.6707L47.45 48.0319C47.2948 48.1601 47.1504 48.2936 47.0113 48.4325C46.717 48.721 46.4548 49.0361 46.2301 49.378Z",
    fill: "url(#paint163_radial_578_447501)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8181 50.1362C46.877 50.2003 46.9412 50.2644 47.0054 50.3285C47.2943 50.617 47.6153 50.8787 47.9578 51.1031C48.2146 50.9322 48.4553 50.7452 48.6854 50.5422C49.0546 50.211 49.381 49.8371 49.6592 49.4204C48.9369 49.6341 47.8775 49.9279 46.8181 50.1362Z",
    fill: "url(#paint164_radial_578_447501)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7854 50.094C46.7961 50.1046 46.8068 50.1207 46.8229 50.1314C46.8817 50.1955 46.9459 50.2596 47.0101 50.3237C47.1599 50.4732 47.3098 50.6121 47.4756 50.7403C47.8823 50.0192 48.3317 49.1538 48.3691 48.8173C48.3638 48.8226 47.4649 49.5651 46.7854 50.094Z",
    fill: "url(#paint165_radial_578_447501)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9582 49.3782L49.3867 48.9669C49.2369 48.78 49.0764 48.5983 48.9105 48.4274C48.8196 48.3366 48.7286 48.2511 48.6323 48.1656L47.9582 49.3782Z",
    fill: "url(#paint166_radial_578_447501)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M47.957 50.5163C48.4065 50.2172 48.7971 49.8326 49.0967 49.3785C48.7971 48.9298 48.4118 48.5399 47.957 48.2407C47.5076 48.5399 47.117 48.9245 46.8174 49.3785C47.117 49.8326 47.5023 50.2172 47.957 50.5163Z",
    fill: "url(#paint167_radial_578_447501)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3859 49.0469C49.2361 48.8599 49.0756 48.6783 48.9097 48.5073C48.8188 48.4165 48.7278 48.3311 48.6315 48.2456C48.4175 48.0586 48.1928 47.8877 47.9574 47.7274C47.7808 47.845 47.6096 47.9678 47.4491 48.1014C47.2939 48.2296 47.1495 48.3631 47.0103 48.502C46.7321 48.7798 46.4807 49.0843 46.2613 49.4101C46.2506 49.3941 46.2452 49.3834 46.2345 49.3674C46.4593 49.0255 46.7214 48.705 47.0103 48.4165C47.1495 48.2776 47.2993 48.1441 47.4491 48.0159C47.6096 47.8824 47.7808 47.7541 47.9574 47.642C48.1928 47.7969 48.4175 47.9732 48.6315 48.1601C48.7278 48.2456 48.8188 48.3311 48.9097 48.4219C49.081 48.5928 49.2415 48.7691 49.3859 48.9614C49.4929 49.0949 49.5892 49.2338 49.6855 49.3727C49.6748 49.3887 49.6695 49.3994 49.6588 49.4155C49.5678 49.2926 49.4769 49.1697 49.3859 49.0469Z",
    fill: "url(#paint168_radial_578_447501)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7861 50.0139C46.7968 50.0245 46.8075 50.0406 46.8236 50.0513C46.8824 50.1154 46.9466 50.1795 47.0109 50.2436C47.1607 50.3931 47.3105 50.532 47.4763 50.6602C47.6315 50.7884 47.792 50.9059 47.9632 51.0181C48.22 50.8472 48.4608 50.6602 48.6909 50.4572C49.0601 50.126 49.3864 49.7521 49.6647 49.3354C49.6754 49.3515 49.6861 49.3622 49.6914 49.3782C49.6807 49.3942 49.67 49.4049 49.6647 49.4209C49.3864 49.8322 49.0601 50.2062 48.6909 50.5427C48.4662 50.7457 48.22 50.938 47.9632 51.1036C47.7974 50.9914 47.6315 50.8739 47.4763 50.7457C47.3158 50.6121 47.1607 50.4733 47.0109 50.329C46.9466 50.2649 46.8878 50.2008 46.8236 50.1367C46.8129 50.126 46.8022 50.11 46.7861 50.0993C46.5828 49.875 46.4009 49.6346 46.2297 49.3835C46.2404 49.3675 46.2511 49.3568 46.2564 49.3408C46.417 49.5758 46.5935 49.8002 46.7861 50.0139Z",
    fill: "url(#paint169_radial_578_447501)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.91 48.5072C49.0759 48.6782 49.2364 48.8598 49.3862 49.0467L49.6338 49.3812C49.3624 49.7795 49.0465 50.1382 48.6909 50.4572C48.4608 50.6602 48.22 50.8471 47.9632 51.0181C47.792 50.9059 47.6315 50.7884 47.4763 50.6602C47.3105 50.532 47.1607 50.3931 47.0109 50.2435L47.0108 50.2435C46.9466 50.1794 46.8824 50.1153 46.8236 50.0512C46.8126 50.0439 46.8041 50.0341 46.7965 50.0252C46.7929 50.0211 46.7895 50.0172 46.7861 50.0138C46.604 49.8117 46.4361 49.6001 46.2827 49.3789C46.497 49.0647 46.7413 48.7708 47.0106 48.5019C47.1498 48.363 47.2942 48.2294 47.4494 48.1012C47.6099 47.9677 47.7811 47.8448 47.9577 47.7273C48.1931 47.8876 48.4178 48.0585 48.6318 48.2455C48.7281 48.3309 48.8191 48.4164 48.91 48.5072ZM46.2379 49.3719C46.2369 49.3704 46.2359 49.3689 46.2348 49.3673C46.4595 49.0254 46.7217 48.7049 47.0106 48.4164C47.1498 48.2775 47.2996 48.144 47.4494 48.0158C47.6099 47.8822 47.7811 47.754 47.9577 47.6418C48.1931 47.7968 48.4178 47.973 48.6318 48.16C48.7281 48.2455 48.8191 48.3309 48.91 48.4218C49.0812 48.5927 49.2418 48.769 49.3862 48.9613C49.4845 49.084 49.5738 49.2112 49.6624 49.3388C49.6631 49.3377 49.6639 49.3365 49.6647 49.3354C49.6678 49.3402 49.671 49.3445 49.6741 49.3486C49.6813 49.3583 49.6877 49.3669 49.6914 49.3781C49.6882 49.3829 49.685 49.3872 49.682 49.3913C49.6748 49.401 49.6684 49.4096 49.6647 49.4209C49.3864 49.8322 49.0601 50.2061 48.6909 50.5426C48.4662 50.7456 48.22 50.9379 47.9632 51.1035C47.7974 50.9914 47.6315 50.8738 47.4763 50.7456C47.3158 50.6121 47.1607 50.4732 47.0109 50.329C46.9787 50.2969 46.948 50.2649 46.9172 50.2328C46.8865 50.2008 46.8557 50.1687 46.8236 50.1367C46.8202 50.1333 46.8168 50.1294 46.8133 50.1253C46.8056 50.1164 46.7971 50.1066 46.7861 50.0993C46.5828 49.8749 46.4009 49.6345 46.2297 49.3835C46.2325 49.3793 46.2352 49.3755 46.2379 49.3719Z",
    fill: "url(#paint170_radial_578_447501)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M47.958 48.2451C47.958 48.2451 47.2839 48.6671 46.8184 49.3829C46.8184 49.3776 47.1501 48.6404 47.958 48.2451Z",
    fill: "url(#paint171_radial_578_447501)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0918 49.3787C49.0918 49.3787 48.6905 50.0838 48.011 50.5058L47.9575 51.0186L47.9201 50.4951C47.9201 50.4951 47.4118 50.2814 46.8179 49.3787C46.8179 49.3787 47.5669 50.3829 47.9682 50.4363C47.9682 50.4417 48.4337 50.2601 49.0918 49.3787Z",
    fill: "url(#paint172_radial_578_447501)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9521 50.511C47.9521 50.511 47.2459 50.1104 46.8232 49.432L46.3096 49.3785L46.8339 49.3411C46.8339 49.3411 47.0479 48.8337 47.9521 48.2407C47.9521 48.2407 46.9463 48.9886 46.8928 49.3892C46.8874 49.3892 47.0693 49.854 47.9521 50.511Z",
    fill: "url(#paint173_radial_578_447501)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9795 48.2407C47.9795 48.2407 48.6857 48.6414 49.1084 49.3198L49.6221 49.3732L49.0977 49.4106C49.0977 49.4106 48.8837 49.9181 47.9795 50.511C47.9795 50.511 48.9854 49.7631 49.0389 49.3625C49.0442 49.3625 48.8623 48.8978 47.9795 48.2407Z",
    fill: "url(#paint174_radial_578_447501)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8179 49.3725C46.8179 49.3725 47.2192 48.6674 47.8987 48.2454L47.9522 47.7325L47.9896 48.256C47.9896 48.256 48.4979 48.4697 49.0918 49.3725C49.0918 49.3725 48.3427 48.3682 47.9415 48.3148C47.9415 48.3095 47.476 48.4911 46.8179 49.3725Z",
    fill: "url(#paint175_radial_578_447501)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6651 46.5339C40.602 46.6249 40.6022 46.7452 40.6654 46.8361C40.8618 47.1186 41.0781 47.3899 41.3101 47.6457C41.3244 47.66 41.3388 47.6815 41.3604 47.6959C41.4394 47.7819 41.5256 47.8679 41.6118 47.9539C41.8129 48.1546 42.0141 48.341 42.2368 48.5131C42.3987 48.6468 42.5649 48.7718 42.7389 48.8915C42.8301 48.9544 42.9506 48.954 43.04 48.8886C43.3838 48.637 43.8584 48.2267 44.2634 47.8164C44.5905 47.485 44.9236 47.0603 45.0942 46.8348C45.1651 46.7413 45.1663 46.6135 45.0983 46.5178C45.0108 46.3946 44.8909 46.2286 44.8086 46.126C44.6075 45.8751 44.392 45.6313 44.1693 45.4019C44.0471 45.2801 43.925 45.1654 43.7957 45.0507C43.5551 44.8406 43.3044 44.6456 43.0436 44.4614C42.9516 44.3965 42.829 44.3958 42.7363 44.4598C42.5538 44.5857 42.3765 44.7171 42.2081 44.8571C41.9997 45.0292 41.8058 45.2084 41.619 45.3948C41.2613 45.7581 40.9433 46.1328 40.6651 46.5339Z",
    fill: "url(#paint176_linear_578_447501)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1584 46.6825C41.3243 46.9336 41.5115 47.174 41.7148 47.3983C41.7255 47.409 41.7362 47.425 41.7523 47.4357C41.8112 47.4998 41.8754 47.5639 41.9396 47.628C42.0894 47.7776 42.2392 47.9165 42.405 48.0447C42.5602 48.1729 42.7207 48.2904 42.8919 48.4026C43.1488 48.2316 43.3895 48.0447 43.6196 47.8417C43.9888 47.5105 44.3151 47.1366 44.5934 46.7199C44.6041 46.7039 44.6148 46.6932 44.6201 46.6772C44.5238 46.5383 44.4275 46.3994 44.3205 46.2658C44.1707 46.0789 44.0102 45.8973 43.8443 45.7263C43.7534 45.6355 43.6624 45.55 43.5661 45.4646C43.3521 45.2776 43.1274 45.1067 42.8919 44.9464C42.7154 45.0639 42.5442 45.1868 42.3836 45.3203C42.2285 45.4485 42.084 45.5821 41.9449 45.721C41.6453 46.0255 41.3831 46.3406 41.1584 46.6825Z",
    fill: "#B9F2FF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1585 46.6828H42.8867V44.9628C42.5443 45.1871 42.2233 45.4489 41.9343 45.7373C41.6454 46.0258 41.3833 46.341 41.1585 46.6828Z",
    fill: "url(#paint177_radial_578_447501)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8871 44.9628V46.6882H44.6152C44.3905 46.3463 44.1283 46.0258 43.8394 45.7373C43.5452 45.4489 43.2295 45.1871 42.8871 44.9628Z",
    fill: "url(#paint178_radial_578_447501)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8871 46.6829V48.4083C43.5719 47.9542 44.1604 47.3666 44.6152 46.6829H42.8871Z",
    fill: "url(#paint179_radial_578_447501)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1585 46.6829C41.3833 47.0247 41.6454 47.3452 41.9343 47.6337C42.2233 47.9222 42.5443 48.1839 42.8867 48.4083V46.6829H41.1585Z",
    fill: "url(#paint180_radial_578_447501)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1588 46.6824C41.3835 47.0243 41.6457 47.3448 41.9346 47.6333C42.2236 47.9218 42.5446 48.1835 42.887 48.4079C43.1438 48.2369 43.2348 48.1782 43.4648 47.9752L42.3787 45.3363C42.2235 45.4645 42.0791 45.5981 41.94 45.7369C41.6457 46.0254 41.3835 46.3406 41.1588 46.6824Z",
    fill: "url(#paint181_radial_578_447501)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7468 47.4407C41.8057 47.5048 41.8699 47.5689 41.9341 47.633C42.223 47.9214 42.544 48.1832 42.8865 48.4075C43.1433 48.2366 43.3841 48.0496 43.6141 47.8466C43.9833 47.5154 44.3097 47.1415 44.5879 46.7249C43.8656 46.9385 42.8062 47.2323 41.7468 47.4407Z",
    fill: "url(#paint182_radial_578_447501)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7141 47.3984C41.7248 47.4091 41.7355 47.4251 41.7516 47.4358C41.8104 47.4999 41.8746 47.564 41.9388 47.6281C42.0887 47.7777 42.2385 47.9166 42.4043 48.0448C42.811 47.3236 43.2604 46.4582 43.2979 46.1217C43.2925 46.127 42.3936 46.8696 41.7141 47.3984Z",
    fill: "url(#paint183_radial_578_447501)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8869 46.6827L44.3154 46.2714C44.1656 46.0844 44.0051 45.9028 43.8392 45.7318C43.7483 45.641 43.6573 45.5556 43.561 45.4701L42.8869 46.6827Z",
    fill: "url(#paint184_radial_578_447501)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8858 47.8208C43.3352 47.5216 43.7258 47.137 44.0254 46.683C43.7258 46.2343 43.3405 45.8443 42.8858 45.5452C42.4363 45.8443 42.0457 46.2289 41.7461 46.683C42.0457 47.137 42.431 47.5216 42.8858 47.8208Z",
    fill: "url(#paint185_radial_578_447501)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3146 46.3513C44.1648 46.1643 44.0043 45.9827 43.8384 45.8118C43.7475 45.721 43.6565 45.6355 43.5602 45.55C43.3462 45.3631 43.1215 45.1921 42.8861 45.0319C42.7095 45.1494 42.5383 45.2723 42.3778 45.4058C42.2226 45.534 42.0782 45.6676 41.9391 45.8064C41.6608 46.0842 41.4094 46.3887 41.19 46.7146C41.1793 46.6985 41.1739 46.6878 41.1632 46.6718C41.388 46.3299 41.6501 46.0094 41.9391 45.721C42.0782 45.5821 42.228 45.4485 42.3778 45.3203C42.5383 45.1868 42.7095 45.0586 42.8861 44.9464C43.1215 45.1013 43.3462 45.2776 43.5602 45.4646C43.6565 45.55 43.7475 45.6355 43.8384 45.7263C44.0097 45.8973 44.1702 46.0735 44.3146 46.2658C44.4216 46.3994 44.518 46.5383 44.6143 46.6772C44.6036 46.6932 44.5982 46.7039 44.5875 46.7199C44.4965 46.597 44.4056 46.4742 44.3146 46.3513Z",
    fill: "url(#paint186_radial_578_447501)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7148 47.3183C41.7255 47.329 41.7362 47.345 41.7523 47.3557C41.8112 47.4198 41.8754 47.4839 41.9396 47.548C42.0894 47.6976 42.2392 47.8365 42.405 47.9647C42.5602 48.0929 42.7207 48.2104 42.8919 48.3226C43.1488 48.1516 43.3895 47.9647 43.6196 47.7617C43.9888 47.4305 44.3151 47.0566 44.5934 46.6399C44.6041 46.6559 44.6148 46.6666 44.6201 46.6826C44.6094 46.6987 44.5987 46.7093 44.5934 46.7254C44.3151 47.1367 43.9888 47.5106 43.6196 47.8471C43.3949 48.0501 43.1488 48.2424 42.8919 48.408C42.7261 48.2959 42.5602 48.1783 42.405 48.0501C42.2445 47.9166 42.0894 47.7777 41.9396 47.6335C41.8754 47.5694 41.8165 47.5053 41.7523 47.4412C41.7416 47.4305 41.7309 47.4145 41.7148 47.4038C41.5115 47.1794 41.3296 46.939 41.1584 46.688C41.1691 46.6719 41.1798 46.6613 41.1852 46.6452C41.3457 46.8803 41.5222 47.1046 41.7148 47.3183Z",
    fill: "url(#paint187_radial_578_447501)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8387 45.8117C44.0046 45.9826 44.1651 46.1642 44.3149 46.3512L44.5625 46.6856C44.2911 47.0839 43.9752 47.4426 43.6196 47.7616C43.3895 47.9646 43.1488 48.1516 42.8919 48.3225C42.7207 48.2103 42.5602 48.0928 42.405 47.9646C42.2392 47.8364 42.0894 47.6975 41.9396 47.5479L41.9396 47.5479C41.8754 47.4838 41.8112 47.4197 41.7523 47.3556C41.7413 47.3483 41.7329 47.3385 41.7252 47.3297C41.7216 47.3256 41.7182 47.3216 41.7148 47.3182C41.5327 47.1162 41.3649 46.9045 41.2114 46.6833C41.4257 46.3692 41.67 46.0752 41.9394 45.8063C42.0785 45.6674 42.2229 45.5339 42.3781 45.4057C42.5386 45.2721 42.7098 45.1493 42.8864 45.0318C43.1218 45.192 43.3465 45.363 43.5605 45.5499C43.6568 45.6354 43.7478 45.7209 43.8387 45.8117ZM41.1666 46.6764C41.1656 46.6749 41.1646 46.6733 41.1635 46.6717C41.3883 46.3298 41.6504 46.0093 41.9394 45.7209C42.0785 45.582 42.2283 45.4484 42.3781 45.3202C42.5386 45.1867 42.7098 45.0585 42.8864 44.9463C43.1218 45.1012 43.3465 45.2775 43.5605 45.4644C43.6568 45.5499 43.7478 45.6354 43.8387 45.7262C44.01 45.8971 44.1705 46.0734 44.3149 46.2657C44.4133 46.3884 44.5025 46.5156 44.5911 46.6432C44.5919 46.6421 44.5926 46.641 44.5934 46.6398C44.5966 46.6446 44.5998 46.6489 44.6028 46.653C44.61 46.6627 44.6164 46.6713 44.6201 46.6826C44.6169 46.6874 44.6137 46.6917 44.6107 46.6958C44.6035 46.7054 44.5971 46.7141 44.5934 46.7253C44.3151 47.1366 43.9888 47.5106 43.6196 47.8471C43.3949 48.0501 43.1488 48.2424 42.8919 48.408C42.7261 48.2958 42.5602 48.1783 42.405 48.0501C42.2445 47.9165 42.0894 47.7776 41.9396 47.6334C41.9075 47.6014 41.8767 47.5693 41.8459 47.5373C41.8152 47.5052 41.7844 47.4732 41.7523 47.4411C41.7489 47.4377 41.7455 47.4338 41.742 47.4297C41.7343 47.4208 41.7258 47.411 41.7148 47.4037C41.5115 47.1794 41.3296 46.939 41.1584 46.6879C41.1612 46.6838 41.1639 46.68 41.1666 46.6764Z",
    fill: "url(#paint188_radial_578_447501)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8867 45.5496C42.8867 45.5496 42.2126 45.9716 41.7471 46.6874C41.7471 46.682 42.0788 45.9449 42.8867 45.5496Z",
    fill: "url(#paint189_radial_578_447501)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0205 46.6831C44.0205 46.6831 43.6192 47.3882 42.9397 47.8102L42.8862 48.323L42.8488 47.7995C42.8488 47.7995 42.3405 47.5859 41.7466 46.6831C41.7466 46.6831 42.4956 47.6874 42.8969 47.7408C42.8969 47.7461 43.3624 47.5645 44.0205 46.6831Z",
    fill: "url(#paint190_radial_578_447501)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8809 47.8154C42.8809 47.8154 42.1746 47.4148 41.7519 46.7364L41.2383 46.683L41.7626 46.6456C41.7626 46.6456 41.9766 46.1381 42.8809 45.5452C42.8809 45.5452 41.875 46.293 41.8215 46.6937C41.8161 46.6937 41.998 47.1584 42.8809 47.8154Z",
    fill: "url(#paint191_radial_578_447501)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9082 45.5452C42.9082 45.5452 43.6145 45.9458 44.0371 46.6242L44.5508 46.6776L44.0264 46.715C44.0264 46.715 43.8124 47.2225 42.9082 47.8154C42.9082 47.8154 43.9141 47.0676 43.9676 46.667C43.9729 46.667 43.791 46.2022 42.9082 45.5452Z",
    fill: "url(#paint192_radial_578_447501)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7466 46.6769C41.7466 46.6769 42.1479 45.9718 42.8274 45.5498L42.8809 45.037L42.9183 45.5605C42.9183 45.5605 43.4266 45.7742 44.0205 46.6769C44.0205 46.6769 43.2715 45.6727 42.8702 45.6192C42.8702 45.6139 42.4047 45.7955 41.7466 46.6769Z",
    fill: "url(#paint193_radial_578_447501)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4473 43.3946C35.3842 43.4856 35.3844 43.606 35.4476 43.6969C35.644 43.9793 35.8604 44.2506 36.0923 44.5064C36.1067 44.5207 36.121 44.5422 36.1426 44.5566C36.2216 44.6426 36.3078 44.7286 36.394 44.8146C36.5952 45.0154 36.7963 45.2017 37.019 45.3738C37.1809 45.5075 37.3471 45.6325 37.5211 45.7523C37.6124 45.8151 37.7328 45.8147 37.8222 45.7493C38.1661 45.4977 38.6406 45.0874 39.0456 44.6771C39.3727 44.3457 39.7058 43.921 39.8765 43.6956C39.9473 43.602 39.9485 43.4742 39.8805 43.3785C39.793 43.2553 39.6731 43.0893 39.5909 42.9867C39.3897 42.7358 39.1742 42.4921 38.9515 42.2627C38.8294 42.1408 38.7072 42.0261 38.5779 41.9114C38.3373 41.7013 38.0866 41.5063 37.8258 41.3221C37.7338 41.2572 37.6112 41.2565 37.5186 41.3205C37.336 41.4465 37.1587 41.5778 36.9903 41.7179C36.782 41.8899 36.588 42.0691 36.4012 42.2555C36.0435 42.6188 35.7255 42.9935 35.4473 43.3946Z",
    fill: "#252525"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9406 43.5432C36.1065 43.7943 36.2938 44.0347 36.4971 44.259C36.5078 44.2697 36.5185 44.2857 36.5345 44.2964C36.5934 44.3605 36.6576 44.4246 36.7218 44.4887C36.8716 44.6383 37.0214 44.7772 37.1873 44.9054C37.3424 45.0336 37.5029 45.1511 37.6742 45.2633C37.931 45.0924 38.1718 44.9054 38.4018 44.7024C38.771 44.3712 39.0974 43.9973 39.3756 43.5806C39.3863 43.5646 39.397 43.5539 39.4023 43.5379C39.306 43.399 39.2097 43.2601 39.1027 43.1266C38.9529 42.9396 38.7924 42.758 38.6265 42.587C38.5356 42.4962 38.4446 42.4108 38.3483 42.3253C38.1343 42.1383 37.9096 41.9674 37.6742 41.8071C37.4976 41.9246 37.3264 42.0475 37.1659 42.1811C37.0107 42.3093 36.8663 42.4428 36.7271 42.5817C36.4275 42.8862 36.1653 43.2013 35.9406 43.5432Z",
    fill: "url(#paint194_radial_578_447501)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9408 43.5436H37.6689V41.8235C37.3265 42.0478 37.0055 42.3096 36.7166 42.5981C36.4277 42.8865 36.1655 43.2017 35.9408 43.5436Z",
    fill: "url(#paint195_radial_578_447501)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6693 41.8235V43.5489H39.3975C39.1727 43.207 38.9106 42.8865 38.6217 42.5981C38.3274 42.3096 38.0117 42.0478 37.6693 41.8235Z",
    fill: "url(#paint196_radial_578_447501)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6693 43.5436V45.269C38.3541 44.8149 38.9427 44.2273 39.3975 43.5436H37.6693Z",
    fill: "url(#paint197_radial_578_447501)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9408 43.5436C36.1655 43.8855 36.4277 44.206 36.7166 44.4944C37.0055 44.7829 37.3265 45.0446 37.6689 45.269V43.5436H35.9408Z",
    fill: "url(#paint198_radial_578_447501)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M35.941 43.5432C36.1658 43.885 36.4279 44.2056 36.7169 44.494C37.0058 44.7825 37.3268 45.0442 37.6692 45.2686C37.926 45.0976 38.017 45.0389 38.2471 44.8359L37.1609 42.197C37.0058 42.3252 36.8613 42.4588 36.7222 42.5977C36.4279 42.8861 36.1658 43.2013 35.941 43.5432Z",
    fill: "url(#paint199_radial_578_447501)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5291 44.3014C36.5879 44.3655 36.6521 44.4296 36.7163 44.4937C37.0052 44.7821 37.3263 45.0439 37.6687 45.2682C37.9255 45.0973 38.1663 44.9103 38.3963 44.7074C38.7655 44.3762 39.0919 44.0022 39.3701 43.5856C38.6478 43.7992 37.5884 44.093 36.5291 44.3014Z",
    fill: "url(#paint200_radial_578_447501)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4964 44.2591C36.5071 44.2698 36.5178 44.2858 36.5338 44.2965C36.5927 44.3606 36.6569 44.4247 36.7211 44.4888C36.8709 44.6384 37.0207 44.7773 37.1866 44.9055C37.5932 44.1843 38.0426 43.319 38.0801 42.9824C38.0747 42.9878 37.1759 43.7303 36.4964 44.2591Z",
    fill: "url(#paint201_radial_578_447501)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6691 43.5434L39.0977 43.1321C38.9478 42.9451 38.7873 42.7635 38.6215 42.5926C38.5305 42.5017 38.4396 42.4163 38.3432 42.3308L37.6691 43.5434Z",
    fill: "url(#paint202_radial_578_447501)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M37.668 44.6815C38.1174 44.3824 38.508 43.9978 38.8076 43.5437C38.508 43.095 38.1228 42.705 37.668 42.4059C37.2185 42.705 36.828 43.0896 36.5283 43.5437C36.828 43.9978 37.2132 44.3824 37.668 44.6815Z",
    fill: "url(#paint203_radial_578_447501)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0969 43.212C38.9471 43.0251 38.7865 42.8434 38.6207 42.6725C38.5297 42.5817 38.4388 42.4962 38.3425 42.4108C38.1284 42.2238 37.9037 42.0529 37.6683 41.8926C37.4917 42.0101 37.3205 42.133 37.16 42.2665C37.0049 42.3947 36.8604 42.5283 36.7213 42.6672C36.4431 42.9449 36.1916 43.2494 35.9722 43.5753C35.9615 43.5593 35.9562 43.5486 35.9455 43.5325C36.1702 43.1907 36.4324 42.8702 36.7213 42.5817C36.8604 42.4428 37.0102 42.3093 37.16 42.1811C37.3205 42.0475 37.4917 41.9193 37.6683 41.8071C37.9037 41.962 38.1284 42.1383 38.3425 42.3253C38.4388 42.4108 38.5297 42.4962 38.6207 42.587C38.7919 42.758 38.9524 42.9343 39.0969 43.1266C39.2039 43.2601 39.3002 43.399 39.3965 43.5379C39.3858 43.5539 39.3804 43.5646 39.3697 43.5806C39.2788 43.4578 39.1878 43.3349 39.0969 43.212Z",
    fill: "url(#paint204_radial_578_447501)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4971 44.179C36.5078 44.1897 36.5185 44.2057 36.5345 44.2164C36.5934 44.2805 36.6576 44.3446 36.7218 44.4087C36.8716 44.5583 37.0214 44.6972 37.1873 44.8254C37.3424 44.9536 37.5029 45.0711 37.6742 45.1833C37.931 45.0124 38.1718 44.8254 38.4018 44.6224C38.771 44.2912 39.0974 43.9173 39.3756 43.5006C39.3863 43.5166 39.397 43.5273 39.4023 43.5433C39.3916 43.5594 39.3809 43.5701 39.3756 43.5861C39.0974 43.9974 38.771 44.3713 38.4018 44.7079C38.1771 44.9109 37.931 45.1032 37.6742 45.2688C37.5083 45.1566 37.3424 45.0391 37.1873 44.9109C37.0268 44.7773 36.8716 44.6384 36.7218 44.4942C36.6576 44.4301 36.5987 44.366 36.5345 44.3019C36.5238 44.2912 36.5131 44.2752 36.4971 44.2645C36.2938 44.0401 36.1118 43.7998 35.9406 43.5487C35.9513 43.5327 35.962 43.522 35.9674 43.506C36.1279 43.741 36.3045 43.9654 36.4971 44.179Z",
    fill: "url(#paint205_radial_578_447501)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.621 42.6724C38.7868 42.8433 38.9473 43.0249 39.0972 43.2119L39.3447 43.5463C39.0733 43.9446 38.7574 44.3033 38.4018 44.6223C38.1718 44.8253 37.931 45.0123 37.6742 45.1832C37.5029 45.0711 37.3424 44.9535 37.1873 44.8253C37.0214 44.6971 36.8716 44.5582 36.7218 44.4087L36.7218 44.4087C36.6576 44.3446 36.5934 44.2805 36.5345 44.2164C36.5236 44.2091 36.5151 44.1993 36.5074 44.1904C36.5038 44.1863 36.5005 44.1823 36.4971 44.179C36.3149 43.9769 36.1471 43.7652 35.9936 43.544C36.208 43.2299 36.4522 42.936 36.7216 42.667C36.8607 42.5282 37.0052 42.3946 37.1603 42.2664C37.3208 42.1329 37.492 42.01 37.6686 41.8925C37.904 42.0527 38.1287 42.2237 38.3428 42.4106C38.4391 42.4961 38.53 42.5816 38.621 42.6724ZM35.9488 43.5371C35.9479 43.5356 35.9468 43.534 35.9458 43.5324C36.1705 43.1905 36.4327 42.87 36.7216 42.5816C36.8607 42.4427 37.0105 42.3091 37.1603 42.1809C37.3208 42.0474 37.492 41.9192 37.6686 41.807C37.904 41.9619 38.1287 42.1382 38.3428 42.3252C38.4391 42.4106 38.53 42.4961 38.621 42.5869C38.7922 42.7579 38.9527 42.9341 39.0972 43.1264C39.1955 43.2491 39.2848 43.3764 39.3733 43.5039C39.3741 43.5028 39.3748 43.5017 39.3756 43.5006C39.3788 43.5053 39.382 43.5096 39.385 43.5138C39.3922 43.5234 39.3986 43.532 39.4023 43.5433C39.3992 43.5481 39.396 43.5524 39.3929 43.5565C39.3857 43.5662 39.3793 43.5748 39.3756 43.586C39.0974 43.9973 38.771 44.3713 38.4018 44.7078C38.1771 44.9108 37.931 45.1031 37.6742 45.2687C37.5083 45.1565 37.3424 45.039 37.1873 44.9108C37.0268 44.7773 36.8716 44.6384 36.7218 44.4941C36.6897 44.4621 36.6589 44.43 36.6282 44.398C36.5974 44.3659 36.5666 44.3339 36.5345 44.3018C36.5311 44.2984 36.5277 44.2945 36.5242 44.2904C36.5165 44.2815 36.508 44.2717 36.4971 44.2644C36.2938 44.0401 36.1118 43.7997 35.9406 43.5486C35.9434 43.5445 35.9462 43.5407 35.9488 43.5371Z",
    fill: "url(#paint206_radial_578_447501)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6689 42.4103C37.6689 42.4103 36.9948 42.8323 36.5293 43.5481C36.5293 43.5427 36.861 42.8056 37.6689 42.4103Z",
    fill: "url(#paint207_radial_578_447501)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8027 43.5438C38.8027 43.5438 38.4015 44.2489 37.722 44.6709L37.6684 45.1838L37.631 44.6603C37.631 44.6603 37.1227 44.4466 36.5288 43.5438C36.5288 43.5438 37.2779 44.5481 37.6791 44.6015C37.6791 44.6068 38.1446 44.4252 38.8027 43.5438Z",
    fill: "url(#paint208_radial_578_447501)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6631 44.6762C37.6631 44.6762 36.9568 44.2755 36.5341 43.5971L36.0205 43.5437L36.5449 43.5063C36.5449 43.5063 36.7589 42.9988 37.6631 42.4059C37.6631 42.4059 36.6572 43.1537 36.6037 43.5544C36.5984 43.5544 36.7803 44.0191 37.6631 44.6762Z",
    fill: "url(#paint209_radial_578_447501)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6904 42.4059C37.6904 42.4059 38.3967 42.8065 38.8194 43.4849L39.333 43.5384L38.8087 43.5757C38.8087 43.5757 38.5947 44.0832 37.6904 44.6762C37.6904 44.6762 38.6963 43.9283 38.7498 43.5277C38.7552 43.5277 38.5732 43.0629 37.6904 42.4059Z",
    fill: "url(#paint210_radial_578_447501)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5288 43.5377C36.5288 43.5377 36.9301 42.8325 37.6096 42.4105L37.6631 41.8977L37.7006 42.4212C37.7006 42.4212 38.2088 42.6349 38.8027 43.5377C38.8027 43.5377 38.0537 42.5334 37.6524 42.48C37.6524 42.4746 37.1869 42.6562 36.5288 43.5377Z",
    fill: "url(#paint211_radial_578_447501)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4424 43.4063C35.3793 43.4973 35.3795 43.6177 35.4427 43.7086C35.6391 43.991 35.8555 44.2623 36.0874 44.5181C36.1018 44.5325 36.1162 44.554 36.1377 44.5683C36.2167 44.6543 36.3029 44.7403 36.3891 44.8264C36.5903 45.0271 36.7914 45.2135 37.0141 45.3855C37.176 45.5192 37.3423 45.6442 37.5162 45.764C37.6075 45.8268 37.7279 45.8265 37.8173 45.761C38.1612 45.5095 38.6357 45.0991 39.0407 44.6888C39.3678 44.3575 39.7009 43.9327 39.8716 43.7073C39.9425 43.6137 39.9436 43.4859 39.8756 43.3902C39.7881 43.267 39.6682 43.101 39.586 42.9984C39.3848 42.7475 39.1693 42.5038 38.9466 42.2744C38.8245 42.1525 38.7024 42.0378 38.5731 41.9231C38.3324 41.713 38.0817 41.518 37.8209 41.3339C37.729 41.2689 37.6064 41.2682 37.5137 41.3322C37.3311 41.4582 37.1539 41.5895 36.9854 41.7296C36.7771 41.9016 36.5831 42.0808 36.3963 42.2672C36.0386 42.6305 35.7206 43.0052 35.4424 43.4063Z",
    fill: "url(#paint212_linear_578_447501)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9357 43.5549C36.1016 43.806 36.2889 44.0464 36.4922 44.2708C36.5029 44.2814 36.5136 44.2975 36.5296 44.3081C36.5885 44.3722 36.6527 44.4363 36.7169 44.5004C36.8667 44.65 37.0165 44.7889 37.1824 44.9171C37.3376 45.0453 37.4981 45.1628 37.6693 45.275C37.9261 45.1041 38.1669 44.9171 38.3969 44.7141C38.7661 44.3829 39.0925 44.009 39.3707 43.5923C39.3814 43.5763 39.3921 43.5656 39.3975 43.5496C39.3012 43.4107 39.2048 43.2718 39.0978 43.1383C38.948 42.9513 38.7875 42.7697 38.6217 42.5988C38.5307 42.5079 38.4397 42.4225 38.3434 42.337C38.1294 42.15 37.9047 41.9791 37.6693 41.8188C37.4927 41.9364 37.3215 42.0592 37.161 42.1928C37.0058 42.321 36.8614 42.4545 36.7223 42.5934C36.4226 42.8979 36.1605 43.2131 35.9357 43.5549Z",
    fill: "#B9F2FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9359 43.5553H37.6641V41.8352C37.3216 42.0596 37.0006 42.3213 36.7117 42.6098C36.4228 42.8982 36.1606 43.2134 35.9359 43.5553Z",
    fill: "url(#paint213_radial_578_447501)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6644 41.8352V43.5606H39.3926C39.1679 43.2187 38.9057 42.8982 38.6168 42.6098C38.3225 42.3213 38.0068 42.0596 37.6644 41.8352Z",
    fill: "url(#paint214_radial_578_447501)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6644 43.5553V45.2807C38.3492 44.8267 38.9378 44.2391 39.3926 43.5553H37.6644Z",
    fill: "url(#paint215_radial_578_447501)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9359 43.5553C36.1606 43.8972 36.4228 44.2177 36.7117 44.5061C37.0006 44.7946 37.3216 45.0564 37.6641 45.2807V43.5553H35.9359Z",
    fill: "url(#paint216_radial_578_447501)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9362 43.5549C36.1609 43.8968 36.423 44.2173 36.712 44.5057C37.0009 44.7942 37.3219 45.0559 37.6643 45.2803C37.9212 45.1094 38.0121 45.0506 38.2422 44.8476L37.1561 42.2087C37.0009 42.3369 36.8564 42.4705 36.7173 42.6094C36.423 42.8978 36.1609 43.213 35.9362 43.5549Z",
    fill: "url(#paint217_radial_578_447501)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5242 44.3131C36.583 44.3772 36.6472 44.4413 36.7114 44.5054C37.0004 44.7939 37.3214 45.0556 37.6638 45.28C37.9206 45.109 38.1614 44.9221 38.3915 44.7191C38.7606 44.3879 39.087 44.014 39.3652 43.5973C38.6429 43.811 37.5836 44.1048 36.5242 44.3131Z",
    fill: "url(#paint218_radial_578_447501)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4915 44.2708C36.5022 44.2815 36.5129 44.2975 36.5289 44.3082C36.5878 44.3723 36.652 44.4364 36.7162 44.5005C36.866 44.6501 37.0158 44.789 37.1817 44.9172C37.5883 44.1961 38.0377 43.3307 38.0752 42.9941C38.0698 42.9995 37.171 43.742 36.4915 44.2708Z",
    fill: "url(#paint219_radial_578_447501)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6642 43.5551L39.0928 43.1438C38.943 42.9568 38.7824 42.7752 38.6166 42.6043C38.5256 42.5135 38.4347 42.428 38.3384 42.3425L37.6642 43.5551Z",
    fill: "url(#paint220_radial_578_447501)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6631 44.6932C38.1125 44.3941 38.5031 44.0095 38.8027 43.5554C38.5031 43.1067 38.1179 42.7167 37.6631 42.4176C37.2137 42.7167 36.8231 43.1014 36.5235 43.5554C36.8231 44.0095 37.2083 44.3941 37.6631 44.6932Z",
    fill: "url(#paint221_radial_578_447501)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M39.092 43.2238C38.9422 43.0368 38.7817 42.8552 38.6158 42.6842C38.5248 42.5934 38.4339 42.5079 38.3376 42.4225C38.1236 42.2355 37.8988 42.0646 37.6634 41.9043C37.4869 42.0218 37.3156 42.1447 37.1551 42.2782C37 42.4064 36.8555 42.54 36.7164 42.6789C36.4382 42.9567 36.1867 43.2611 35.9673 43.587C35.9566 43.571 35.9513 43.5603 35.9406 43.5443C36.1653 43.2024 36.4275 42.8819 36.7164 42.5934C36.8555 42.4545 37.0053 42.321 37.1551 42.1928C37.3156 42.0592 37.4869 41.931 37.6634 41.8188C37.8988 41.9738 38.1236 42.15 38.3376 42.337C38.4339 42.4225 38.5248 42.5079 38.6158 42.5988C38.787 42.7697 38.9475 42.946 39.092 43.1383C39.199 43.2718 39.2953 43.4107 39.3916 43.5496C39.3809 43.5656 39.3756 43.5763 39.3648 43.5923C39.2739 43.4695 39.1829 43.3466 39.092 43.2238Z",
    fill: "url(#paint222_radial_578_447501)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4922 44.1907C36.5029 44.2014 36.5136 44.2175 36.5296 44.2281C36.5885 44.2922 36.6527 44.3563 36.7169 44.4204C36.8667 44.57 37.0165 44.7089 37.1824 44.8371C37.3376 44.9653 37.4981 45.0828 37.6693 45.195C37.9261 45.0241 38.1669 44.8371 38.3969 44.6341C38.7661 44.3029 39.0925 43.929 39.3707 43.5123C39.3814 43.5284 39.3921 43.539 39.3975 43.5551C39.3868 43.5711 39.3761 43.5818 39.3707 43.5978C39.0925 44.0091 38.7661 44.383 38.3969 44.7196C38.1722 44.9226 37.9261 45.1149 37.6693 45.2805C37.5034 45.1683 37.3376 45.0508 37.1824 44.9226C37.0219 44.789 36.8667 44.6501 36.7169 44.5059C36.6527 44.4418 36.5938 44.3777 36.5296 44.3136C36.5189 44.3029 36.5082 44.2869 36.4922 44.2762C36.2889 44.0519 36.107 43.8115 35.9357 43.5604C35.9464 43.5444 35.9571 43.5337 35.9625 43.5177C36.123 43.7527 36.2996 43.9771 36.4922 44.1907Z",
    fill: "url(#paint223_radial_578_447501)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6161 42.6841C38.782 42.855 38.9425 43.0367 39.0923 43.2236L39.3398 43.558C39.0684 43.9564 38.7525 44.315 38.3969 44.6341C38.1669 44.837 37.9261 45.024 37.6693 45.195C37.4981 45.0828 37.3376 44.9653 37.1824 44.837C37.0165 44.7088 36.8667 44.57 36.7169 44.4204L36.7169 44.4204C36.6527 44.3563 36.5885 44.2922 36.5296 44.2281C36.5187 44.2208 36.5102 44.211 36.5025 44.2021C36.499 44.198 36.4956 44.1941 36.4922 44.1907C36.31 43.9886 36.1422 43.7769 35.9887 43.5557C36.2031 43.2416 36.4474 42.9477 36.7167 42.6788C36.8558 42.5399 37.0003 42.4063 37.1554 42.2781C37.3159 42.1446 37.4872 42.0217 37.6637 41.9042C37.8991 42.0644 38.1239 42.2354 38.3379 42.4224C38.4342 42.5078 38.5251 42.5933 38.6161 42.6841ZM35.944 43.5488C35.943 43.5473 35.942 43.5457 35.9409 43.5441C36.1656 43.2023 36.4278 42.8818 36.7167 42.5933C36.8558 42.4544 37.0056 42.3209 37.1554 42.1927C37.3159 42.0591 37.4872 41.9309 37.6637 41.8187C37.8991 41.9736 38.1239 42.1499 38.3379 42.3369C38.4342 42.4224 38.5251 42.5078 38.6161 42.5986C38.7873 42.7696 38.9478 42.9459 39.0923 43.1382C39.1906 43.2609 39.2799 43.3881 39.3684 43.5157C39.3692 43.5145 39.37 43.5134 39.3707 43.5123C39.3739 43.5171 39.3771 43.5214 39.3801 43.5255C39.3873 43.5351 39.3937 43.5438 39.3975 43.555C39.3943 43.5598 39.3911 43.5641 39.388 43.5682C39.3808 43.5779 39.3745 43.5865 39.3707 43.5977C39.0925 44.0091 38.7661 44.383 38.3969 44.7195C38.1722 44.9225 37.9261 45.1148 37.6693 45.2804C37.5034 45.1682 37.3376 45.0507 37.1824 44.9225C37.0219 44.789 36.8667 44.6501 36.7169 44.5059C36.6848 44.4738 36.654 44.4418 36.6233 44.4097C36.5925 44.3777 36.5617 44.3456 36.5296 44.3135C36.5263 44.3102 36.5229 44.3062 36.5193 44.3021C36.5116 44.2933 36.5032 44.2835 36.4922 44.2762C36.2889 44.0518 36.107 43.8114 35.9357 43.5603C35.9385 43.5562 35.9413 43.5524 35.944 43.5488Z",
    fill: "url(#paint224_radial_578_447501)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6641 42.422C37.6641 42.422 36.9899 42.844 36.5244 43.5598C36.5244 43.5545 36.8562 42.8173 37.6641 42.422Z",
    fill: "url(#paint225_radial_578_447501)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7979 43.5555C38.7979 43.5555 38.3966 44.2607 37.7171 44.6827L37.6636 45.1955L37.6261 44.672C37.6261 44.672 37.1178 44.4583 36.5239 43.5555C36.5239 43.5555 37.273 44.5598 37.6743 44.6132C37.6743 44.6186 38.1398 44.4369 38.7979 43.5555Z",
    fill: "url(#paint226_radial_578_447501)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6582 44.6879C37.6582 44.6879 36.9519 44.2872 36.5293 43.6088L36.0156 43.5554L36.54 43.518C36.54 43.518 36.754 43.0105 37.6582 42.4176C37.6582 42.4176 36.6523 43.1655 36.5988 43.5661C36.5935 43.5661 36.7754 44.0308 37.6582 44.6879Z",
    fill: "url(#paint227_radial_578_447501)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6855 42.4176C37.6855 42.4176 38.3918 42.8182 38.8145 43.4967L39.3281 43.5501L38.8038 43.5875C38.8038 43.5875 38.5898 44.0949 37.6855 44.6879C37.6855 44.6879 38.6914 43.94 38.7449 43.5394C38.7503 43.5394 38.5684 43.0746 37.6855 42.4176Z",
    fill: "url(#paint228_radial_578_447501)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5239 43.5494C36.5239 43.5494 36.9252 42.8442 37.6047 42.4222L37.6582 41.9094L37.6957 42.4329C37.6957 42.4329 38.204 42.6466 38.7979 43.5494C38.7979 43.5494 38.0488 42.5451 37.6475 42.4917C37.6475 42.4863 37.182 42.668 36.5239 43.5494Z",
    fill: "url(#paint229_radial_578_447501)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_578_447501",
    x: 0.854372,
    y: 0.146298,
    width: 94.2512,
    height: 63.4602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.253841
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.55377
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_447501"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_578_447501",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_578_447501",
    x: 34.8332,
    y: 16.4653,
    width: 26.2633,
    height: 30.9323,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.253841
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.380761
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_447501"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_578_447501",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_578_447501",
    x1: 33.0793,
    y1: 49.3035,
    x2: 63.8372,
    y2: 49.3035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471832,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506947,
    stopColor: "#A6ADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.6639 55.6957) scale(16.4716 7.56175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.625 44.4124) rotate(-1.17394) scale(29.4674 93.2926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175545,
    stopColor: "#DFEAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35104,
    stopColor: "#CFD5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490869,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523393,
    stopColor: "#AFAFBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651458,
    stopColor: "#B5BAC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970701,
    stopColor: "#D6F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_578_447501",
    x1: 68.2165,
    y1: 38.1639,
    x2: 31.9936,
    y2: 38.1639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273069,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852689,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5878 51.4218) scale(19.0284 23.2269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1742,
    stopColor: "white",
    stopOpacity: 0.8258
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4223,
    stopColor: "white",
    stopOpacity: 0.5777
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7131,
    stopColor: "white",
    stopOpacity: 0.2869
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.0268 16.2593) rotate(37.6425) scale(24.6412 24.6295)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6F6F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.9084 23.651) scale(11.2893 11.268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#676767",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#707070",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#7F7F7F",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#949494",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_578_447501",
    x1: 66.5589,
    y1: 24.5899,
    x2: 76.9384,
    y2: 5.19435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9FA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#363434"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.8638 20.8668) scale(12.4538 12.4304)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#CBCBCB",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#C2C2C2",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#B3B3B3",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#9E9E9E",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.8168 26.5842) scale(11.0256 11.0048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#676767",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#707070",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#7F7F7F",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#949494",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.4241 24.5069) scale(11.1018 11.0809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#F4F4F4",
    stopOpacity: 0.8774
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    stopColor: "white",
    stopOpacity: 0.7027
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5031,
    stopColor: "white",
    stopOpacity: 0.4969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7328,
    stopColor: "white",
    stopOpacity: 0.2672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9794,
    stopColor: "white",
    stopOpacity: 0.0206021
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.6194 19.0931) scale(5.82126 5.81034)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "white",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "white",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "white",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "white",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.3881 10.7258) rotate(7.64247) scale(24.6412 24.6295)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.6422 12.1863) rotate(-30) scale(11.2893 11.268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#1A1A1A",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#232323",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#323232",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#474747",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5B5B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_578_447501",
    x1: 65.4883,
    y1: 23.1742,
    x2: 64.7795,
    y2: 1.18736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.7465 11.7974) rotate(-30) scale(12.4538 12.4304)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#7E7E7E",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#757575",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#666666",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#525252",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4B4B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.0388 22.2722) rotate(-30) scale(11.0256 11.0048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#1A1A1A",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#232323",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#323232",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#474747",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5B5B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.1245 18.6696) rotate(-30) scale(11.1018 11.0809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#A8A8A8",
    stopOpacity: 0.8774
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    stopColor: "#B2B2B2",
    stopOpacity: 0.7027
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5031,
    stopColor: "#B3B3B3",
    stopOpacity: 0.4969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7328,
    stopColor: "#B3B3B3",
    stopOpacity: 0.2672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9794,
    stopColor: "#B3B3B3",
    stopOpacity: 0.0206021
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.7829 10.8835) rotate(-30) scale(5.82126 5.81034)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#B3B3B3",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#B3B3B3",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#B3B3B3",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#B3B3B3",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2487 10.8355) rotate(172.358) scale(24.6412 24.6295)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9945 12.296) rotate(-150) scale(11.2893 11.268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#1A1A1A",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#232323",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#323232",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#474747",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5B5B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_578_447501",
    x1: 29.1484,
    y1: 23.2839,
    x2: 29.8572,
    y2: 1.2971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8902 11.9071) rotate(-150) scale(12.4538 12.4304)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#7E7E7E",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#757575",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#666666",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#525252",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4B4B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.5979 22.382) rotate(-150) scale(11.0256 11.0048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#1A1A1A",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#232323",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#323232",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#474747",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5B5B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5122 18.7794) rotate(-150) scale(11.1018 11.0809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#A8A8A8",
    stopOpacity: 0.8774
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    stopColor: "#B2B2B2",
    stopOpacity: 0.7027
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5031,
    stopColor: "#B3B3B3",
    stopOpacity: 0.4969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7328,
    stopColor: "#B3B3B3",
    stopOpacity: 0.2672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9794,
    stopColor: "#B3B3B3",
    stopOpacity: 0.0206021
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8538 10.9932) rotate(-150) scale(5.82126 5.81034)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#B3B3B3",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#B3B3B3",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#B3B3B3",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#B3B3B3",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_578_447501",
    x1: 76.8807,
    y1: 5.61026,
    x2: 65.642,
    y2: 39.8799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_578_447501",
    x1: 93.8962,
    y1: 0.9483,
    x2: 74.3832,
    y2: 27.0823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.941 27.0902) rotate(8.95217) scale(14.8665 15.469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.4249 27.4123) rotate(-8.56738) scale(19.2495 19.2132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697476,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.4429 34.2051) rotate(-87.7034) scale(13.7665 50.9253)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175545,
    stopColor: "#DFEAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35104,
    stopColor: "#CFD5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486433,
    stopColor: "#D6F3FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.0471 28.1776) scale(14.5935 14.566)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_578_447501",
    x1: 79.3038,
    y1: 37.102,
    x2: 62.7163,
    y2: 39.5998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550832,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799171,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535455"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_578_447501",
    x1: 59.7003,
    y1: 37.1926,
    x2: 69.3346,
    y2: 36.4028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#899196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292633,
    stopColor: "#9099A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510317,
    stopColor: "#CFD5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880118,
    stopColor: "#D6F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_578_447501",
    x1: 50.5954,
    y1: 35.4784,
    x2: 72.912,
    y2: 17.4293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53805,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#464646"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.9988 20.6287) rotate(135.782) scale(38.5825 36.0839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382062,
    stopColor: "#424242",
    stopOpacity: 0.8668
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422608,
    stopColor: "#464646",
    stopOpacity: 0.666
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5749,
    stopColor: "#646464",
    stopOpacity: 0.4225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8483,
    stopColor: "#8D8D8D",
    stopOpacity: 0.1479
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#969696",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_578_447501",
    x1: 55.8968,
    y1: 38.3093,
    x2: 70.2878,
    y2: 22.2014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479337,
    stopColor: "#A09E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614565,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646867,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825054,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#464646"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.8339 31.3701) rotate(-19.3843) scale(6.80491 6.79494)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#9A9A9A",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#A3A3A3",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#B2B2B2",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#C7C7C7",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_578_447501",
    x1: 66.3848,
    y1: 20.1978,
    x2: 63.4321,
    y2: 37.4336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.2882 32.2923) rotate(-19.7864) scale(4.53485 4.60689)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00184208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "white",
    stopOpacity: 0.8725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3103,
    stopColor: "white",
    stopOpacity: 0.691
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5238,
    stopColor: "#F9F9F9",
    stopOpacity: 0.477
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7618,
    stopColor: "#E3E3E3",
    stopOpacity: 0.2386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.2813 26.8571) rotate(-19.3842) scale(5.03101 5.0236)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00184208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "white",
    stopOpacity: 0.8725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3103,
    stopColor: "white",
    stopOpacity: 0.691
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5238,
    stopColor: "#F9F9F9",
    stopOpacity: 0.477
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7618,
    stopColor: "#E3E3E3",
    stopOpacity: 0.2386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.5563 24.9014) rotate(-19.3843) scale(10.6709 10.6552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5338,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3282 20.8121) rotate(-19.3842) scale(11.2375 11.221)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0494498,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3559,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8515,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.5339 25.3897) rotate(-19.3842) scale(4.10393 4.09789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0239829,
    stopColor: "white",
    stopOpacity: 0.976
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2786,
    stopColor: "white",
    stopOpacity: 0.7214
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5124,
    stopColor: "white",
    stopOpacity: 0.4876
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7181,
    stopColor: "white",
    stopOpacity: 0.2819
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8876,
    stopColor: "white",
    stopOpacity: 0.1124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.7764 29.9781) rotate(-40.0106) scale(20.3473 20.3174)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675217,
    stopColor: "#FFFEFE",
    stopOpacity: 0.7718
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "white",
    stopOpacity: 0.3025
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8779,
    stopColor: "white",
    stopOpacity: 0.1206
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.9331 16.2593) rotate(142.358) scale(24.6412 24.6295)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6F6F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.05155 23.651) rotate(180) scale(11.2893 11.268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#676767",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#707070",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#7F7F7F",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#949494",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_578_447501",
    x1: 29.4011,
    y1: 24.5899,
    x2: 19.0216,
    y2: 5.19435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9FA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#363434"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0962 20.8668) rotate(180) scale(12.4538 12.4304)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#CBCBCB",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#C2C2C2",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#B3B3B3",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#9E9E9E",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1432 26.5842) rotate(180) scale(11.0256 11.0048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#676767",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#707070",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#7F7F7F",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#949494",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5359 24.5069) rotate(180) scale(11.1018 11.0809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#F4F4F4",
    stopOpacity: 0.8774
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    stopColor: "white",
    stopOpacity: 0.7027
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5031,
    stopColor: "white",
    stopOpacity: 0.4969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7328,
    stopColor: "white",
    stopOpacity: 0.2672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9794,
    stopColor: "white",
    stopOpacity: 0.0206021
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.3406 19.0931) rotate(180) scale(5.82126 5.81034)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "white",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "white",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "white",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "white",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_578_447501",
    x1: 19.0792,
    y1: 5.61014,
    x2: 30.3179,
    y2: 39.8797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_578_447501",
    x1: 2.0638,
    y1: 0.948178,
    x2: 21.5767,
    y2: 27.0822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.019 27.0901) rotate(171.048) scale(14.8665 15.469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.534 27.4123) rotate(-171.433) scale(19.2495 19.2132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697476,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5161 34.2051) rotate(-92.2966) scale(13.7665 50.9253)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175545,
    stopColor: "#DFEAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35104,
    stopColor: "#CFD5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486433,
    stopColor: "#D6F3FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.9109 28.1776) rotate(-180) scale(14.5935 14.566)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_578_447501",
    x1: 16.6552,
    y1: 37.1019,
    x2: 33.2427,
    y2: 39.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550832,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799171,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535455"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_578_447501",
    x1: 36.2587,
    y1: 37.1924,
    x2: 26.6244,
    y2: 36.4026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#899196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292633,
    stopColor: "#9099A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510317,
    stopColor: "#CFD5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880118,
    stopColor: "#D6F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_578_447501",
    x1: 45.6966,
    y1: 35.4784,
    x2: 23.38,
    y2: 17.4293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53805,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#464646"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2931 20.6287) rotate(44.2182) scale(38.5825 36.0839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382062,
    stopColor: "#424242",
    stopOpacity: 0.8668
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422608,
    stopColor: "#464646",
    stopOpacity: 0.666
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5749,
    stopColor: "#646464",
    stopOpacity: 0.4225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8483,
    stopColor: "#8D8D8D",
    stopOpacity: 0.1479
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#969696",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_578_447501",
    x1: 40.0632,
    y1: 38.3093,
    x2: 25.6722,
    y2: 22.2014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479337,
    stopColor: "#A09E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614565,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646867,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825054,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#464646"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1261 31.3701) rotate(-160.616) scale(6.80491 6.79494)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#9A9A9A",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#A3A3A3",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#B2B2B2",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#C7C7C7",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_578_447501",
    x1: 29.5752,
    y1: 20.1978,
    x2: 32.5279,
    y2: 37.4336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.886 32.4858) rotate(-160.616) scale(5.02282 5.01547)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00184208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "white",
    stopOpacity: 0.8725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3103,
    stopColor: "white",
    stopOpacity: 0.691
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5238,
    stopColor: "#F9F9F9",
    stopOpacity: 0.477
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7618,
    stopColor: "#E3E3E3",
    stopOpacity: 0.2386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6786 26.8571) rotate(-160.616) scale(5.03101 5.0236)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00184208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "white",
    stopOpacity: 0.8725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3103,
    stopColor: "white",
    stopOpacity: 0.691
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5238,
    stopColor: "#F9F9F9",
    stopOpacity: 0.477
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7618,
    stopColor: "#E3E3E3",
    stopOpacity: 0.2386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8383 20.3254) rotate(-160.616) scale(11.0401 11.0239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00184208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "white",
    stopOpacity: 0.8725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3103,
    stopColor: "white",
    stopOpacity: 0.691
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5238,
    stopColor: "#F9F9F9",
    stopOpacity: 0.477
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7618,
    stopColor: "#E3E3E3",
    stopOpacity: 0.2386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4037 24.9013) rotate(-160.616) scale(10.6709 10.6552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5338,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6317 20.812) rotate(-160.616) scale(11.2375 11.221)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0494498,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3559,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8515,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4261 25.3895) rotate(-160.616) scale(4.10393 4.09789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0239829,
    stopColor: "white",
    stopOpacity: 0.976
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2786,
    stopColor: "white",
    stopOpacity: 0.7214
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5124,
    stopColor: "white",
    stopOpacity: 0.4876
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7181,
    stopColor: "white",
    stopOpacity: 0.2819
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8876,
    stopColor: "white",
    stopOpacity: 0.1124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.1836 29.978) rotate(-139.989) scale(20.3473 20.3174)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675217,
    stopColor: "#FFFEFE",
    stopOpacity: 0.7718
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "white",
    stopOpacity: 0.3025
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8779,
    stopColor: "white",
    stopOpacity: 0.1206
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.782 16.9665) scale(8.56951 8.55332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2003,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5023,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.3772 17.2595) scale(11.6159 11.594)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2596,
    stopColor: "white",
    stopOpacity: 0.7404
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6291,
    stopColor: "white",
    stopOpacity: 0.3709
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_578_447501",
    x1: 57.6514,
    y1: 18.2078,
    x2: 57.6514,
    y2: 22.6752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_578_447501",
    x1: 52.1132,
    y1: 13.3822,
    x2: 52.1132,
    y2: 19.2556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.075 18.5256) scale(3.58632 3.57961)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2084,
    stopColor: "white",
    stopOpacity: 0.7916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5052,
    stopColor: "white",
    stopOpacity: 0.4948
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8531,
    stopColor: "white",
    stopOpacity: 0.1469
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_578_447501",
    x1: 55.0258,
    y1: 17.4406,
    x2: 54.9842,
    y2: 26.0038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.173119,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612905,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874877,
    stopColor: "#EDEDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.1144 17.0013) rotate(180) scale(8.56953 8.5534)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2003,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5023,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5192 17.2944) rotate(180) scale(11.6159 11.594)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2596,
    stopColor: "white",
    stopOpacity: 0.7404
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6291,
    stopColor: "white",
    stopOpacity: 0.3709
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_578_447501",
    x1: 38.2736,
    y1: 18.2413,
    x2: 38.2736,
    y2: 22.7088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_578_447501",
    x1: 43.8117,
    y1: 13.4162,
    x2: 43.8117,
    y2: 19.2896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.8218 18.56) rotate(180) scale(3.58632 3.57952)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2084,
    stopColor: "#F0F0F0",
    stopOpacity: 0.7916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5052,
    stopColor: "#EEEEEE",
    stopOpacity: 0.4948
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8531,
    stopColor: "#DCDCDC",
    stopOpacity: 0.1469
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D4D4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_578_447501",
    x1: 41.0394,
    y1: 17.4735,
    x2: 40.998,
    y2: 26.0368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.173119,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612905,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874877,
    stopColor: "#EDEDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_578_447501",
    x1: 35.6199,
    y1: 43.1922,
    x2: 43.3698,
    y2: 37.7566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#464646"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_578_447501",
    x1: 60.2297,
    y1: 43.1922,
    x2: 52.4798,
    y2: 37.7566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#464646"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_578_447501",
    x1: 53.5761,
    y1: 12.0295,
    x2: 47.4879,
    y2: 46.0523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_578_447501",
    x1: 47.9764,
    y1: 49.4698,
    x2: 47.9764,
    y2: 0.335569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1465,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4124,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8568,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B9B9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.872 12.3251) rotate(90) scale(18.2322 17.3323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9913 31.5563) scale(11.982 12.2545)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0A0A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_578_447501",
    x1: 36.8655,
    y1: 21.7968,
    x2: 28.3812,
    y2: 28.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_578_447501",
    x1: 35.5575,
    y1: 36.8055,
    x2: 48.3266,
    y2: 43.9819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490869,
    stopColor: "#C3C7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992945,
    stopColor: "#D6F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_578_447501",
    x1: 47.9041,
    y1: 36.8055,
    x2: 60.6793,
    y2: 43.9919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490869,
    stopColor: "#C3C7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992945,
    stopColor: "#D6F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_578_447501",
    x1: 56.9533,
    y1: 15.5658,
    x2: 55.9459,
    y2: 25.4583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_578_447501",
    x1: 44.5984,
    y1: 15.5658,
    x2: 43.5901,
    y2: 25.4581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.1531 14.0313) scale(19.2253 19.6625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#888888",
    stopOpacity: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3418,
    stopColor: "#989898",
    stopOpacity: 0.6582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#B1B1B1",
    stopOpacity: 0.4216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8401,
    stopColor: "#D4D4D4",
    stopOpacity: 0.1599
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.1463 12.7239) scale(23.2589 23.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#888888",
    stopOpacity: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3418,
    stopColor: "#989898",
    stopOpacity: 0.6582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#B1B1B1",
    stopOpacity: 0.4216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8401,
    stopColor: "#D4D4D4",
    stopOpacity: 0.1599
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6757 31.3252) scale(14.147 14.4688)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#888888",
    stopOpacity: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3418,
    stopColor: "#989898",
    stopOpacity: 0.6582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#B1B1B1",
    stopOpacity: 0.4216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8401,
    stopColor: "#D4D4D4",
    stopOpacity: 0.1599
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.8221 18.5122) scale(14.0331 14.3523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#888888",
    stopOpacity: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3418,
    stopColor: "#989898",
    stopOpacity: 0.6582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#B1B1B1",
    stopOpacity: 0.4216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8401,
    stopColor: "#D4D4D4",
    stopOpacity: 0.1599
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.1509 30.8241) scale(15.6486 16.0046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#888888",
    stopOpacity: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3418,
    stopColor: "#989898",
    stopOpacity: 0.6582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#B1B1B1",
    stopOpacity: 0.4216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8401,
    stopColor: "#D4D4D4",
    stopOpacity: 0.1599
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.8166 44.1786) scale(11.8161 12.0848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#888888",
    stopOpacity: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3418,
    stopColor: "#989898",
    stopOpacity: 0.6582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#B1B1B1",
    stopOpacity: 0.4216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8401,
    stopColor: "#D4D4D4",
    stopOpacity: 0.1599
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_578_447501",
    x1: 48.2343,
    y1: 12.6876,
    x2: 47.9719,
    y2: 54.1226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.173119,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612905,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874877,
    stopColor: "#EDEDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_578_447501",
    x1: 59.8694,
    y1: 27.546,
    x2: 54.119,
    y2: 34.2301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_578_447501",
    x1: 36.8313,
    y1: 27.546,
    x2: 31.0809,
    y2: 34.2301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00613581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473769,
    stopColor: "#CACBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21394,
    stopColor: "#EDEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312779,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352236,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818717,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868789"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7346 41.8249) rotate(-89.2588) scale(27.7057 33.108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175545,
    stopColor: "#BDD3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35104,
    stopColor: "#B0BAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486433,
    stopColor: "#B0E7F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8824 21.0996) scale(21.6045 21.5638)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9633 47.409) scale(20.0971 20.0592)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.803 21.2753) scale(14.9415 14.9132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2689 35.6694) scale(11.6205 11.5986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2039 42.8283) scale(12.4562 12.4327)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.2285 45.1894) scale(18.0233 17.9895)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5525 25.5562) scale(7.96084 7.94591)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#FBFBFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.107 14.1444) scale(20.4383 20.3998)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.4298 27.2823) scale(8.42139 8.40553)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#FBFBFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3892 27.1653) scale(7.41445 7.40048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#FBFBFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.4306 34.6319) scale(9.98713 9.96832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#FBFBFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.5944 33.9754) scale(25.4456 11.9142)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.9003 33.6616) rotate(-49.561) scale(7.49103 10.7861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2791 32.6671) rotate(-71.8484) scale(4.3056 3.71746)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.3416 28.6342) scale(10.5042 0.680256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.5502 28.6433) scale(7.24429 0.699711)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.4936 33.9234) scale(9.91558 10.7675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_578_447501",
    x1: 60.4282,
    y1: 44.0697,
    x2: 56.8687,
    y2: 42.3896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#464646"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.1286 44.3828) rotate(180) scale(2.66966 2.66539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9665 41.6444) rotate(180) scale(2.60449 2.60032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.7676 42.8199) rotate(180) scale(3.51233 3.50671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.6037 44.9109) rotate(180) scale(2.11594 2.11255)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.7081 42.6025) rotate(180) scale(2.42762 2.42373)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0228 42.7339) rotate(180) scale(3.62997 3.62416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.6377 46.3109) rotate(180) scale(3.71539 3.70944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.4371 41.6194) rotate(180) scale(2.23461 2.23103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.0733 42.9037) rotate(180) scale(5.04918 5.04109)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.0822 41.6411) rotate(180) scale(3.28429 3.27903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.0819 45.3264) rotate(180) scale(2.91092 2.90625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.0819 45.3263) rotate(180) scale(2.91092 2.90626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2713 42.7862) rotate(180) scale(2.31162 2.30792)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.1436 44.4814) rotate(180) scale(2.0105 2.00728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.1559 43.5861) rotate(-90) scale(2.00728 2.0105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.0601 43.4951) rotate(90) scale(2.00728 2.0105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.0525 42.5993) scale(2.0105 2.00728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_578_447501",
    x1: 55.3569,
    y1: 47.2089,
    x2: 51.7974,
    y2: 45.5288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#464646"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.0573 47.5221) rotate(180) scale(2.66966 2.66539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.8952 44.7837) rotate(180) scale(2.60449 2.60032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6963 45.9591) rotate(180) scale(3.51233 3.50671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.5324 48.0502) rotate(180) scale(2.11594 2.11255)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.6368 45.7418) rotate(180) scale(2.42762 2.42373)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.9515 45.8731) rotate(180) scale(3.62997 3.62416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5664 49.4502) rotate(180) scale(3.71539 3.70944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.3658 44.7587) rotate(180) scale(2.23461 2.23103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.002 46.043) rotate(180) scale(5.04918 5.04109)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.0109 44.7804) rotate(180) scale(3.28429 3.27903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.0106 48.4657) rotate(180) scale(2.91092 2.90625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.0106 48.4656) rotate(180) scale(2.91092 2.90626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2 45.9255) rotate(180) scale(2.31162 2.30792)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.0723 47.6206) rotate(180) scale(2.0105 2.00728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.0846 46.7254) rotate(-90) scale(2.00728 2.0105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9888 46.6344) rotate(90) scale(2.00728 2.0105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9812 45.7386) scale(2.0105 2.00728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_578_447501",
    x1: 50.2856,
    y1: 49.9045,
    x2: 46.7261,
    y2: 48.2244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#464646"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.986 50.2177) rotate(180) scale(2.66966 2.66539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.8239 47.4793) rotate(180) scale(2.60449 2.60032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.625 48.6547) rotate(180) scale(3.51233 3.50671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.4611 50.7457) rotate(180) scale(2.11594 2.11255)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5655 48.4374) rotate(180) scale(2.42762 2.42373)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.8802 48.5687) rotate(180) scale(3.62997 3.62416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.4952 52.1457) rotate(180) scale(3.71539 3.70944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2945 47.4542) rotate(180) scale(2.23461 2.23103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9307 48.7386) rotate(180) scale(5.04918 5.04109)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9396 47.476) rotate(180) scale(3.28429 3.27903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9393 51.1612) rotate(180) scale(2.91092 2.90625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9393 51.1612) rotate(180) scale(2.91092 2.90626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1287 48.621) rotate(180) scale(2.31162 2.30792)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.001 50.3162) rotate(180) scale(2.0105 2.00728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0133 49.4209) rotate(-90) scale(2.00728 2.0105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.9176 49.33) rotate(90) scale(2.00728 2.0105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9099 48.4341) scale(2.0105 2.00728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_578_447501",
    x1: 45.2143,
    y1: 47.2089,
    x2: 41.6548,
    y2: 45.5288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#464646"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.9147 47.5221) rotate(180) scale(2.66966 2.66539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.7526 44.7837) rotate(180) scale(2.60449 2.60032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5537 45.9591) rotate(180) scale(3.51233 3.50671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3898 48.0502) rotate(180) scale(2.11594 2.11255)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4942 45.7418) rotate(180) scale(2.42762 2.42373)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.809 45.8731) rotate(180) scale(3.62997 3.62416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.4239 49.4502) rotate(180) scale(3.71539 3.70944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.2232 44.7587) rotate(180) scale(2.23461 2.23103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.8595 46.043) rotate(180) scale(5.04918 5.04109)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.8683 44.7804) rotate(180) scale(3.28429 3.27903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.868 48.4657) rotate(180) scale(2.91092 2.90625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.868 48.4656) rotate(180) scale(2.91092 2.90626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.0574 45.9255) rotate(180) scale(2.31162 2.30792)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.9297 47.6206) rotate(180) scale(2.0105 2.00728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.9421 46.7254) rotate(-90) scale(2.00728 2.0105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.8463 46.6344) rotate(90) scale(2.00728 2.0105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.8386 45.7386) scale(2.0105 2.00728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6753 41.4672) rotate(180) scale(5.20897 5.20063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#56AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73D8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6969 44.3828) rotate(180) scale(2.66966 2.66539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#113D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5348 41.6444) rotate(180) scale(2.60449 2.60032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.3359 42.8199) rotate(180) scale(3.51233 3.50671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#113D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.1721 44.9109) rotate(180) scale(2.11594 2.11255)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2764 42.6025) rotate(180) scale(2.42762 2.42373)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5912 42.7339) rotate(180) scale(3.62997 3.62416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2061 46.3109) rotate(180) scale(3.71539 3.70944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#113D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0054 41.6194) rotate(180) scale(2.23461 2.23103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#113D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6417 42.9037) rotate(180) scale(5.04918 5.04109)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#C6D8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6505 41.6411) rotate(180) scale(3.28429 3.27903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#C6D8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6502 45.3264) rotate(180) scale(2.91092 2.90625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAF3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6502 45.3263) rotate(180) scale(2.91092 2.90626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAF3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8397 42.7862) rotate(180) scale(2.31162 2.30792)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAF3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.712 44.4814) rotate(180) scale(2.0105 2.00728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAF3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7243 43.5861) rotate(-90) scale(2.00728 2.0105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAF3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.6285 43.4951) rotate(90) scale(2.00728 2.0105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAF3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6209 42.5993) scale(2.0105 2.00728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAF3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428DE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_578_447501",
    x1: 39.9917,
    y1: 44.0814,
    x2: 36.4322,
    y2: 42.4013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#464646"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint213_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.692 44.3945) rotate(180) scale(2.66966 2.66539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint214_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5299 41.6562) rotate(180) scale(2.60449 2.60032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint215_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.3311 42.8316) rotate(180) scale(3.51233 3.50671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint216_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.1672 44.9226) rotate(180) scale(2.11594 2.11255)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2716 42.6143) rotate(180) scale(2.42762 2.42373)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint218_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5863 42.7456) rotate(180) scale(3.62997 3.62416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint219_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2012 46.3226) rotate(180) scale(3.71539 3.70944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0005 41.6311) rotate(180) scale(2.23461 2.23103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint221_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6368 42.9155) rotate(180) scale(5.04918 5.04109)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint222_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6457 41.6529) rotate(180) scale(3.28429 3.27903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint223_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6453 45.3381) rotate(180) scale(2.91092 2.90625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint224_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6453 45.338) rotate(180) scale(2.91092 2.90626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint225_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8348 42.7979) rotate(180) scale(2.31162 2.30792)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint226_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.7071 44.4931) rotate(180) scale(2.0105 2.00728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint227_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7194 43.5978) rotate(-90) scale(2.00728 2.0105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint228_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.6236 43.5068) rotate(90) scale(2.00728 2.0105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint229_radial_578_447501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.616 42.611) scale(2.0105 2.00728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinum);
export default __webpack_public_path__ + "static/media/platinum.7945cc3ea0298a964be64bcceb0fbddd.svg";
export { ForwardRef as ReactComponent };